// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FlightForm - Responsive Styles
 * Matches MUI theme defaults: xs 0–599, sm 600–899, md 900+.
 * Mobile/tablet UI (bottom sheets, compact strip): max-width 899.98px — same as \`theme.breakpoints.down('md')\`.
 * Desktop: min-width 900px — \`theme.breakpoints.up('md')\`.
 */

/* ===== Base resets (all devices) ===== */
.special-fares-row,
.special-fares-slider-wrap,
.special-fares-options,
.flight-tracker-btn,
.flight-search-strip {
  -webkit-tap-highlight-color: transparent;
  text-size-adjust: 100%;
  box-sizing: border-box;
}

.flight-search-strip {
  position: relative;
}

.special-fares-row {
  width: 100%;
  display: flex;
  box-sizing: border-box;
}

.special-fares-slider-wrap {
  width: 100%;
}

.flight-tracker-btn {
  appearance: none;
}

/* Horizontal fare “slider”: touch momentum + snap (no radio UI). */
.special-fares-slider {
  scroll-snap-type: x proximity;
}

.special-fares-options {
  scrollbar-width: none;
  -ms-overflow-style: none;
  display: flex;
}

.special-fares-options::-webkit-scrollbar {
  display: none;
}

.special-fares-options > div {
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

/* ===============================================
   DESKTOP (md / 900px+) — layout from JSX
   =============================================== */
@media (min-width: 900px) {
  .flight-search-strip input {
    font-size: inherit;
  }

  /*
   * Homepage FlightForm — one-way / round-trip desktop strip:
   * one label row + one value row across From, To, dates, travelers, class.
   */
  .flight-search-strip--ow-rt {
    align-items: flex-start;
  }

  .flight-search-strip--ow-rt > .flight-search-strip-airport-field,
  .flight-search-strip--ow-rt > .flight-search-strip-date-field,
  .flight-search-strip--ow-rt > .flight-search-strip-dates-row,
  .flight-search-strip--ow-rt > .flight-search-strip-travelers-field,
  .flight-search-strip--ow-rt > .flight-search-strip-class-field {
    justify-content: flex-start;
  }

  .flight-search-strip--ow-rt .flight-search-strip-airport-field > .MuiTypography-root:first-of-type,
  .flight-search-strip--ow-rt .flight-search-strip-travelers-field > .MuiTypography-root:first-of-type {
    min-height: 20px;
    line-height: 20px !important;
    margin-bottom: 4px !important;
  }

  .flight-search-strip--ow-rt .flight-search-strip-date-field > .MuiBox-root:first-child,
  .flight-search-strip--ow-rt .flight-search-strip-dates-row .flight-search-strip-date-field > .MuiBox-root:first-child,
  .flight-search-strip--ow-rt .flight-search-strip-class-field > .MuiBox-root:first-child {
    min-height: 20px;
    margin-bottom: 4px !important;
    align-items: center;
  }

  .flight-search-strip--ow-rt .flight-search-strip-airport-field .MuiAutocomplete-root .MuiOutlinedInput-root,
  .flight-search-strip--ow-rt .flight-search-strip-date-field .MuiOutlinedInput-root,
  .flight-search-strip--ow-rt .flight-search-strip-dates-row .MuiOutlinedInput-root,
  .flight-search-strip--ow-rt .flight-search-strip-travelers-field .MuiOutlinedInput-root,
  .flight-search-strip--ow-rt .flight-search-strip-class-field .MuiOutlinedInput-root {
    min-height: 32px !important;
    height: 32px !important;
  }

  .flight-search-strip--ow-rt .flight-search-strip-airport-field .MuiInputBase-input,
  .flight-search-strip--ow-rt .flight-search-strip-date-field .MuiInputBase-input,
  .flight-search-strip--ow-rt .flight-search-strip-dates-row .flight-search-strip-date-field .MuiInputBase-input,
  .flight-search-strip--ow-rt .flight-search-strip-travelers-field .MuiInputBase-input,
  .flight-search-strip--ow-rt .flight-search-strip-class-field .MuiInputBase-input,
  .flight-search-strip--ow-rt .flight-search-strip-class-field .MuiSelect-select {
    min-height: 32px !important;
    height: 32px !important;
    line-height: 32px !important;
    padding: 0 !important;
    box-sizing: border-box;
  }

  .flight-search-strip--ow-rt > .flight-form-swap-col {
    align-self: flex-start;
    margin-top: 24px;
  }

  /* 48px CTA vertically centered against 12px/16px label + 4px gap + 32px value */
  .flight-search-strip--ow-rt > .flight-search-strip-cta-field {
    align-self: flex-start;
    margin-top: 4px;
  }
}


/* ===============================================
   MOBILE + TABLET (below md / <900px)
   =============================================== */
@media (max-width: 899.98px) {
  /* Search strip: FROM/TO side by side, other fields stack full-width */
  .flight-search-strip {
    flex-direction: row !important;
    flex-wrap: wrap !important;
    gap: 0 !important;
    padding: 0 !important;
    border: none !important;
    border-radius: 0 !important;
    align-items: center !important;
    background: transparent !important;
  }

  /* Prevent iOS input zoom — use max() so JSX font-size can still win when larger */
  .flight-search-strip input {
    font-size: max(16px, inherit);
    appearance: none;
  }

  .special-fares-slider-wrap {
    padding-left: 0 !important;
  }

  .special-fares-options {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
    flex-wrap: nowrap !important;
    padding-bottom: 6px;
    scroll-snap-type: x proximity;
  }

  .special-fares-options > div {
    flex-shrink: 0;
    scroll-snap-align: start;
    min-height: var(--yovo-tap-min);
  }

  /* From | swap | To — single full-width divider; swap centered on vertical rule */
  .flight-search-strip-from-to-row {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    width: 100%;
    flex: 1 1 100%;
    border-bottom: 1px solid #E8E9ED;
    box-sizing: border-box;
  }

  .flight-search-strip-from-to-row > .flight-search-strip-airport-field {
    flex: 1 1;
    min-width: 0;
    border-bottom: none !important;
  }

  .flight-search-strip-airport-field .MuiOutlinedInput-root {
    min-height: unset !important;
    height: auto !important;
    padding: 0 !important;
  }

  .flight-search-strip-airport-field .MuiInputBase-input {
    line-height: 1.75rem !important;
    height: auto !important;
    padding: 0 !important;
  }

  /* Swap column — fixed width; long airport names never shift the control (<900px) */
  .flight-form-swap-col {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 40px;
    width: 40px;
    min-width: 40px;
    align-self: stretch;
    border-bottom: none !important;
    padding: 0;
    box-sizing: border-box;
  }

  .flight-form-swap-divider {
    display: block;
  }
}

/* ===== Figma 2819:182406 — flight form swap (one-way, round-trip, multicity; all breakpoints) ===== */
.flight-form-swap {
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 50%;
  background: var(--neutrals-base-white, #FBFBFB);
  border: 1px solid var(--neutrals-grey-600, #717180);
  box-shadow: none;
  cursor: pointer;
  box-sizing: border-box;
  transition: background-color 0.2s ease;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.flight-form-swap:hover {
  background: var(--Neutrals-grey-200, #F3F3F7);
}

.flight-form-swap:active {
  background: var(--Neutrals-grey-300, #E8E9ED);
}

.flight-form-swap:focus {
  outline: none;
}

.flight-form-swap:focus-visible {
  outline: 2px solid rgba(26, 24, 39, 0.35);
  outline-offset: 2px;
}

.flight-form-swap-icon {
  width: 16px;
  height: 16px;
  display: block;
  flex-shrink: 0;
}

/* Vertical rule — Figma imgGroup1000001799; grey-400, passes behind the circle */
.flight-form-swap-divider {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 1px;
  margin-left: -0.5px;
  background: var(--neutrals-grey-400, #DAD9E0);
  z-index: 0;
  pointer-events: none;
}

/* Mobile/tablet: clip vertical rule to swap zone — clear gap above horizontal From/To border */
@media (max-width: 899.98px) {
  .flight-form-swap-divider {
    top: 50%;
    bottom: auto;
    height: 44px;
    transform: translate(-50%, -50%);
    margin-left: 0;
  }
}

@media (min-width: 900px) {
  .flight-form-swap-col {
    flex: 0 0 auto;
    width: auto;
    min-width: auto;
    align-self: center;
  }

  /* Desktop multicity / strip: same button; no full-height vertical rule */
  .flight-form-swap-divider {
    display: none;
  }
}

@media (max-width: 899.98px) {
  /* Class — match Travel Date / Travelers label-to-value spacing; no trailing divider */
  .flight-search-strip-class-field {
    border-bottom: none !important;
    padding-bottom: 0 !important;
  }

  /* Travel Date & Travelers — tighter gap below value before divider (~50% less bottom pad) */
  .flight-search-strip-date-field .MuiTextField-root,
  .flight-search-strip-travelers-field .MuiTextField-root,
  .flight-search-strip-date-field .MuiFormControl-root,
  .flight-search-strip-travelers-field .MuiFormControl-root {
    margin-bottom: 0 !important;
  }

  .flight-search-strip-date-field .MuiOutlinedInput-root,
  .flight-search-strip-travelers-field .MuiOutlinedInput-root {
    min-height: unset !important;
    height: auto !important;
    padding: 0 !important;
    margin-bottom: 0 !important;
  }

  .flight-search-strip-date-field .MuiInputBase-input,
  .flight-search-strip-travelers-field .MuiInputBase-input {
    padding: 0 !important;
    line-height: 22px !important;
    height: auto !important;
  }

  .flight-search-strip-class-field .MuiTextField-root,
  .flight-search-strip-class-field .MuiFormControl-root {
    margin-bottom: 0 !important;
  }

  .flight-search-strip-class-field .MuiOutlinedInput-root {
    min-height: unset !important;
    height: auto !important;
    padding: 0 !important;
    margin-bottom: 0 !important;
  }

  .flight-search-strip-class-field .MuiInputBase-input {
    padding: 0 !important;
    line-height: 22px !important;
    height: auto !important;
  }
}

/* ===== iOS safe area (landscape on touch devices only) ===== */
@supports (padding-left: env(safe-area-inset-left)) {
  @media (orientation: landscape) and (hover: none) and (pointer: coarse) {
    .special-fares-slider-wrap {
      padding-left: env(safe-area-inset-left);
      padding-right: env(safe-area-inset-right);
    }
  }
}

/* ===== iOS Safari flexbox fixes ===== */
@supports (-webkit-touch-callout: none) {
  .special-fares-options {
    overscroll-behavior: contain;
  }

  .flight-search-strip {
    -webkit-overflow-scrolling: touch;
  }
}


/* ===============================================
   Airport Dropdown — Search Bar + Options
   =============================================== */

.flight-dropdown-search-bar {
  display: flex;
  align-items: center;
  background: #F4F5F7;
  border: 1px solid #E6E7ED;
  border-radius: 10px;
  padding: 8px 10px;
  gap: 10px;
}

.flight-dropdown-search-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.flight-dropdown-search-input {
  border: none;
  background: transparent;
  outline: none;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
  color: #20202A;
  width: 100%;
  min-width: 0;
  appearance: none;
}

.flight-dropdown-search-clear {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #7E808F;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.flight-dropdown-search-clear:hover {
  background: #E4E5EA;
  color: #20202A;
}

.flight-dropdown-search-input::placeholder {
  color: #AEAEB8;
  opacity: 1;
}

.flight-dropdown-empty {
  padding: 16px 12px 8px;
  text-align: center;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #8B8D98;
  list-style: none;
}

.flight-dropdown-separator {
  padding: 3px 10px !important;
  background: #EEF0FB !important;
  color: #4E5694 !important;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 18px !important;
  border-radius: 6px;
  margin: 6px 4px !important;
  cursor: default !important;
  pointer-events: none;
  display: inline-flex !important;
  align-items: center;
  width: fit-content !important;
  min-height: auto !important;
  box-sizing: border-box;
}

.flight-dropdown-option {
  padding: 10px 8px;
  font-size: 14px;
  line-height: 1.35;
  display: flex !important;
  align-items: center !important;
  cursor: pointer;
  background-color: transparent;
  transition: background-color 0.15s ease;
  min-height: auto;
  width: 100%;
  box-sizing: border-box;
}

.flight-dropdown-option:hover {
  background-color: #EDEDF0;
}

.flight-dropdown-option[data-nearest="true"] {
  padding: 10px 8px 10px 36px !important;
}

.flight-dropdown-option-icon {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  flex-shrink: 0;
  margin-top: 0 !important;
  align-self: center;
  display: block;
  filter: brightness(0);
}

.flight-dropdown-option-content {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.flight-dropdown-option-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
}

.flight-dropdown-option-city {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-weight: 600;
  color: #20202A;
  font-size: 15px;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.flight-dropdown-option-airport {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.1px;
  color: #8E909C;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.flight-dropdown-option-code {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-weight: 600;
  color: #545665;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.3px;
  flex-shrink: 0;
  margin-left: 8px;
  align-self: center;
  background: #F1F2F6;
  border-radius: 8px;
  padding: 2px 8px;
  min-width: 42px;
  text-align: center;
}

/* Mobile: full-width dropdown */
@media (max-width: 899.98px) {
  .flight-dropdown-search-bar {
    padding: 10px 10px;
    gap: 12px;
  }
}


/* ===============================================
   Mobile airport bottom sheet (From / To — Portal)
   Fixed bottom, dvh + safe-area for iOS; list scrolls inside sheet.
   =============================================== */
.mobile-airport-sheet-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1300;
  background: rgba(32, 32, 42, 0.45);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.22s ease, visibility 0.22s ease;
  -webkit-tap-highlight-color: transparent;
}

.mobile-airport-sheet-backdrop.open {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

/* Airport sheet: shared shell (FlightForm mobile Portal). Breakpoints align with MUI md (900px). */
.mobile-airport-sheet {
  position: fixed;
  z-index: 1301;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background: #fff;
  transform: translate3d(0, 100%, 0);
  transition: transform 0.28s cubic-bezier(0.32, 0.72, 0, 1);
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
}

/* xs + sm: half bottom sheet — Figma 6544:98008 (not full-screen) */
@media (max-width: 899.98px) {
  .mobile-airport-sheet {
    inset: auto 0 0 0;
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    height: auto;
    min-height: min(42dvh, 100dvh);
    max-height: min(58dvh, calc(100dvh - env(safe-area-inset-top, 0px) - 3.5rem));
    border-radius: 16px 16px 0 0;
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.12);
    background: #fafafd;
    padding-top: 0;
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }

  /* Typing: fill the visual viewport so the airport list sits above the keyboard. */
  .mobile-airport-sheet.open.is-keyboard-open {
    bottom: var(--mobile-keyboard-inset, 0px);
    height: var(--mobile-vv-height, 100dvh);
    min-height: 0;
    max-height: var(--mobile-vv-height, 100dvh);
    padding-bottom: 0;
  }
}

.mobile-airport-sheet.open {
  transform: translate3d(0, 0, 0);
}

/* Closed sheet must not paint or intercept touches (Android scroll peek guard). */
.mobile-airport-sheet:not(.open) {
  visibility: hidden;
  pointer-events: none;
}

/* Keep handle / header / inputs from shrinking; only the results list flexes and scrolls */
.mobile-airport-sheet > *:not(.mobile-sheet-results) {
  flex-shrink: 0;
}

/* Mobile date picker bottom sheet — matches airport sheet UX; stacks above airport layer */
.mobile-date-sheet-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1310;
  background: rgba(32, 32, 42, 0.45);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.22s ease, visibility 0.22s ease;
  -webkit-tap-highlight-color: transparent;
}

.mobile-date-sheet-backdrop.open {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.mobile-airport-sheet.mobile-date-picker-sheet {
  z-index: 1311;
}

@media (max-width: 899.98px) {
  .mobile-airport-sheet.mobile-date-picker-sheet {
    height: auto;
    min-height: min(60dvh, 100dvh);
    max-height: 100dvh;
  }
}

.mobile-date-picker-scroll-area {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
  touch-action: pan-y;
  padding: 0 0.75rem 1rem;
  padding-bottom: max(1rem, env(safe-area-inset-bottom, 0px));
}

/* Mobile date picker: bottom sheet + rounded top corners (Search Date) */
.mobile-date-fullscreen-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1399;
  background: rgba(32, 32, 42, 0.45);
  -webkit-tap-highlight-color: transparent;
}

.mobile-date-fullscreen-sheet {
  position: fixed;
  z-index: 1400;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  background: #fbfbfb;
  overflow: hidden;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

/* xs + sm: full-screen journey duration / Search Date — matches Travellers & Class */
@media (max-width: 899.98px) {
  .mobile-date-fullscreen-sheet {
    inset: 0;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100vh;
    height: 100dvh;
    min-height: 100vh;
    min-height: 100dvh;
    max-height: 100vh;
    max-height: 100dvh;
    border-radius: 0;
    box-shadow: none;
    padding-top: env(safe-area-inset-top, 0px);
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }
}

.mobile-date-fullscreen-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 10px;
  box-sizing: border-box;
}

.mobile-date-fullscreen-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
  touch-action: pan-y;
  padding: 8px 12px 12px;
}

.mobile-date-fullscreen-datepicker-wrap {
  width: 100%;
  max-width: 100%;
}

.mobile-fullscreen-datepicker.react-datepicker {
  display: flex !important;
  flex-direction: column !important;
  width: 100% !important;
  max-width: 100% !important;
  border: none !important;
  box-shadow: none !important;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  background: transparent !important;
}

.mobile-fullscreen-datepicker .react-datepicker__month-container {
  width: 100% !important;
  float: none !important;
  margin-bottom: 1rem;
}

.mobile-date-fullscreen-footer {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 9px 16px 12px;
  padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));
  background: #fbfbfb;
  border-top: 1px solid #e8e9ed;
  box-sizing: border-box;
  overflow: visible;
}

.mobile-date-fullscreen-summary-row {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  position: relative;
  width: 100%;
  overflow: visible;
  box-sizing: border-box;
}

.mobile-date-summary-box-wrap {
  position: relative;
  flex: 1 1;
  min-width: 0;
  overflow: visible;
  box-sizing: border-box;
}

.mobile-date-summary-box-wrap--full {
  flex: 1 1 100%;
}

/* Figma 6544:99362 — top-right corner of chip, half overlaps border */
.mobile-date-summary-clear {
  position: absolute;
  top: 0;
  right: 0;
  left: auto;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 30px;
  background: #717180;
  cursor: pointer;
  transform: translate(50%, -50%);
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
  line-height: 0;
}

.mobile-date-fullscreen-summary-box {
  flex: 1 1;
  min-width: 0;
  width: 100%;
  height: 56px;
  min-height: 56px;
  max-height: 56px;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 8px 16px;
  box-sizing: border-box;
  background: #f3f3f7;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: left;
  overflow: hidden;
}

.mobile-date-fullscreen-summary-box--interactive {
  margin: 0;
  appearance: none;
  -webkit-appearance: none;
  font: inherit;
  color: inherit;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  box-shadow: none;
}

.mobile-date-fullscreen-summary-box--interactive:focus,
.mobile-date-fullscreen-summary-box--interactive:focus-visible,
.mobile-date-fullscreen-summary-box--interactive:active {
  outline: none !important;
  box-shadow: none !important;
}

.mobile-date-fullscreen-summary-box.mobile-date-fullscreen-summary-box--return-empty {
  align-items: center;
  justify-content: center;
  text-align: center;
}

.mobile-date-summary-return-placeholder {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #9e9e9e;
  width: 100%;
  text-align: center;
}

button.mobile-date-fullscreen-summary-box {
  margin: 0;
  appearance: none;
  -webkit-appearance: none;
  font: inherit;
  color: inherit;
  width: 100%;
  border: 1px solid transparent !important;
  background: #f3f3f7 !important;
  outline: none;
  box-shadow: none;
}

button.mobile-date-fullscreen-summary-box:focus,
button.mobile-date-fullscreen-summary-box:focus-visible,
button.mobile-date-fullscreen-summary-box:active {
  outline: none !important;
  box-shadow: none !important;
}

.mobile-date-fullscreen-summary-box.active {
  /* filled — stroke only on focused segment (see below) */
}

/* Figma 6544:99353/99354 — 1px #252637 stroke on active footer chip */
[data-mobile-date-sheet] .mobile-date-fullscreen-footer .mobile-date-fullscreen-summary-box[data-segment-focused='true'],
[data-mobile-date-sheet] .mobile-date-fullscreen-footer .mobile-date-fullscreen-summary-box.hotel-date-segment-focused,
[data-mobile-date-sheet] .mobile-date-fullscreen-footer .mobile-date-fullscreen-summary-box.flight-date-segment-focused,
[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box[data-segment-focused='true'],
[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.hotel-date-segment-focused,
[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.flight-date-segment-focused,
[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.flight-date-segment-focused:focus,
[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.flight-date-segment-focused:active,
[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.hotel-date-segment-focused:focus,
[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.hotel-date-segment-focused:active {
  border: 1px solid #252637 !important;
  background: #f3f3f7 !important;
  outline: none !important;
  box-shadow: none !important;
}

[data-mobile-date-sheet] .mobile-date-fullscreen-footer .mobile-date-fullscreen-summary-box:not([data-segment-focused='true']):not(.hotel-date-segment-focused):not(.flight-date-segment-focused),
[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box:not([data-segment-focused='true']):not(.hotel-date-segment-focused):not(.flight-date-segment-focused) {
  border: 1px solid transparent !important;
  outline: none !important;
  box-shadow: none !important;
}

/* Legacy selectors — keep for sheets without data-mobile-date-sheet wrapper */
.mobile-date-fullscreen-footer .mobile-date-fullscreen-summary-box.hotel-date-segment-focused,
.mobile-date-fullscreen-footer .mobile-date-fullscreen-summary-box.flight-date-segment-focused,
.mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.hotel-date-segment-focused,
.mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.flight-date-segment-focused {
  border: 1px solid #252637 !important;
  background: #f3f3f7 !important;
  outline: none !important;
  box-shadow: none !important;
}

.mobile-date-fullscreen-footer .mobile-date-fullscreen-summary-box:not(.hotel-date-segment-focused):not(.flight-date-segment-focused),
.mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box:not(.hotel-date-segment-focused):not(.flight-date-segment-focused) {
  border: 1px solid transparent !important;
  outline: none !important;
  box-shadow: none !important;
}

/* Save — Figma 6544:99370 */
.mobile-date-fullscreen-save.MuiButton-root {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
  text-transform: none !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 22px !important;
  min-height: 48px !important;
  padding: 8px 32px !important;
  border-radius: 4px !important;
  background-color: #1a1827 !important;
  color: #fbfbfb !important;
  box-shadow: none !important;
}

.mobile-date-fullscreen-save.MuiButton-root:hover {
  background-color: #252637 !important;
  box-shadow: none !important;
}

.mobile-date-fullscreen-save.MuiButton-root.Mui-disabled {
  background-color: #c3c3cd !important;
  color: #f5f5f7 !important;
}

/* Round-trip: Departure + Return side by side inside one strip cell */
.flight-search-strip-dates-row {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  box-sizing: border-box;
  position: relative;
  min-width: 0;
}

.flight-search-strip-dates-row > .flight-search-strip-date-field {
  flex: 1 1;
  min-width: 0;
}

/* Narrower desktops: wrap whole fields. Dates and counts keep their text width. */
@media (min-width: 900px) and (max-width: 1199.98px) {
  .flight-search-strip:not(.flight-select-hero-strip) {
    flex-wrap: wrap;
    column-gap: 16px;
    row-gap: 0;
    justify-content: flex-start;
  }

  .flight-search-strip--ow-rt:not(.flight-select-hero-strip) > .flight-search-strip-from-to-row {
    display: flex;
    flex: 0 0 auto;
    align-items: flex-start;
    gap: 12px;
    width: auto;
  }

  .flight-search-strip--ow-rt:not(.flight-select-hero-strip) > .flight-search-strip-from-to-row > .flight-form-swap-col {
    align-self: flex-start;
    margin-top: 24px;
  }

  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-date-field,
  .flight-search-strip:not(.flight-select-hero-strip) .flight-search-strip-dates-row > .flight-search-strip-date-field {
    flex: 0 0 auto;
    min-width: 112px;
  }

  .flight-search-strip:not(.flight-select-hero-strip) .flight-search-strip-dates-row {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
    min-width: 0;
    column-gap: 12px;
  }

  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-travelers-field {
    flex: 0 0 auto;
    width: 152px;
    min-width: 152px;
    max-width: 152px;
  }

  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-travelers-field .MuiInputBase-root,
  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-travelers-field .MuiInputBase-input {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 152px;
  }

  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-class-field {
    flex: 0 0 auto;
    width: auto;
    min-width: 5.5rem;
  }
}

/* Wide desktop: fields share the row and Let's Go stays at the end. Dates still cannot shrink away. */
@media (min-width: 1200px) {
  .flight-search-strip:not(.flight-select-hero-strip) {
    flex-wrap: nowrap !important;
    column-gap: 24px;
    row-gap: 0;
  }

  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-airport-field {
    flex: 1.1 1;
    width: auto;
    max-width: none;
  }

  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-date-field {
    flex: 1 1;
    min-width: 112px;
  }

  .flight-search-strip:not(.flight-select-hero-strip) .flight-search-strip-dates-row {
    flex: 1.3 1;
    width: auto;
    max-width: none;
    min-width: 224px;
    column-gap: 16px;
  }

  .flight-search-strip:not(.flight-select-hero-strip) .flight-search-strip-dates-row > .flight-search-strip-date-field {
    flex: 1 1;
    min-width: 112px;
  }

  .flight-search-strip:not(.flight-select-hero-strip) .flight-search-strip-dates-row > .flight-search-strip-date-field:last-of-type {
    padding-left: 0;
  }

  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-travelers-field {
    flex: 1 1;
    min-width: 152px;
  }

  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-class-field {
    flex: 0 0 7.75rem;
    width: 7.75rem;
  }
}

@media (min-width: 900px) {
  /*
   * FlightSelect hero — flat grid:
   * RT: Journey | [From⇄To] | Dep | Ret | Travellers | Class | CTA(auto)
   * OW: Journey | [From⇄To] | Dep | Travellers | Class | CTA(auto)
   */
  .flight-select-hero-strip {
    display: grid !important;
    align-items: start;
    column-gap: clamp(8px, 1vw, 14px);
    width: 100%;
    flex-wrap: unset !important;
    justify-content: unset;
  }

  .flight-select-hero-strip--roundtrip {
    grid-template-columns:
      auto
      minmax(0, 2.4fr)
      repeat(4, minmax(0, 1fr))
      auto;
  }

  .flight-select-hero-strip--oneway {
    grid-template-columns:
      auto
      minmax(0, 2.4fr)
      repeat(3, minmax(0, 1fr))
      auto;
  }

  /* MC: Journey | From | To | Dates | Travellers | Class | CTA(auto) */
  .flight-select-hero-strip--multicity {
    grid-template-columns:
      auto
      repeat(2, minmax(0, 1.2fr))
      repeat(3, minmax(0, 1fr))
      auto;
  }

  .flight-select-hero-strip > .flight-select-hero-meta-group,
  .flight-select-hero-strip .flight-search-strip-dates-row {
    display: contents;
  }

  /* Single grid cell: From + swap overlay + To */
  .flight-select-hero-strip > .flight-select-hero-from-to-group {
    display: flex !important;
    flex-direction: row;
    align-items: stretch;
    position: relative;
    min-width: 0;
    gap: 0;
  }

  .flight-select-hero-from-to-group > .flight-select-hero-airport-field {
    flex: 1 1;
    min-width: 0;
    overflow: hidden;
  }

  /*
   * Figma-style From | swap | To (reference):
   *   label + city left-stacked per side, fixed swap column, equal flex halves
   */
  .flight-select-hero-from-to-group > .flight-select-hero-airport-field--from,
  .flight-select-hero-from-to-group > .flight-select-hero-airport-field--to {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .flight-select-hero-from-to-group > .flight-select-hero-airport-field--from {
    padding-right: 0.75rem;
  }

  .flight-select-hero-from-to-group > .flight-select-hero-airport-field--to {
    padding-left: 0.75rem;
  }

  .flight-select-hero-from-to-group .flight-select-hero-airport-label,
  .flight-select-hero-from-to-group .flight-select-hero-airport-value,
  .flight-select-hero-from-to-group .MuiAutocomplete-input,
  .flight-select-hero-from-to-group .MuiInputBase-input,
  .flight-select-hero-from-to-group .MuiOutlinedInput-input {
    text-align: left;
  }

  .flight-select-hero-from-to-group .flight-select-hero-airport-label {
    justify-content: flex-start;
  }

  .flight-select-hero-from-to-group > .flight-form-swap-col.flight-select-hero-swap-field {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 40px;
    width: 40px;
    min-width: 40px;
    align-self: flex-start;
    margin-top: calc(18px + 4px + (28px - 32px) / 2);
    z-index: 3;
    overflow: visible;
    pointer-events: none;
    border-bottom: none !important;
    padding: 0;
    box-sizing: border-box;
  }

  .flight-select-hero-from-to-group > .flight-form-swap-col.flight-select-hero-swap-field .flight-form-swap {
    position: relative;
    z-index: 1;
    pointer-events: auto;
  }

  /* Vertical rule bisects swap circle — same as Figma / mobile FlightForm */
  .flight-select-hero-from-to-group > .flight-form-swap-col.flight-select-hero-swap-field .flight-form-swap-divider {
    display: block !important;
    left: 50%;
    top: 50%;
    bottom: auto;
    width: 1px;
    height: 2.75rem;
    margin: 0;
    transform: translate(-50%, -50%);
    z-index: 0;
  }

  .flight-select-hero-strip .flight-select-hero-journey-field {
    min-width: 0;
    flex: unset !important;
    padding-left: 0 !important;
    padding-right: clamp(0.25rem, 0.5vw, 0.5rem) !important;
  }

  .flight-select-hero-strip .flight-search-strip-date-field,
  .flight-select-hero-strip .flight-select-hero-duration-field,
  .flight-select-hero-strip .flight-search-strip-travelers-field,
  .flight-select-hero-strip .flight-select-hero-class-field {
    min-width: 0;
    overflow: hidden;
    flex: unset !important;
    padding-left: 0;
    padding-right: 0;
    align-items: flex-start;
    text-align: left;
  }

  .flight-select-hero-strip .flight-select-hero-label-row,
  .flight-select-hero-strip .flight-select-hero-airport-label,
  .flight-select-hero-strip .flight-search-strip-date-field .flight-select-hero-date-label,
  .flight-select-hero-strip .flight-select-hero-duration-field .flight-select-hero-date-label {
    display: flex;
    align-items: center;
    width: 100%;
    height: 18px;
    min-height: 18px;
    padding: 0;
    margin: 0;
  }

  .flight-select-hero-strip .flight-select-hero-option-dropdown button {
    font-size: 1rem;
    font-weight: 700;
    line-height: 28px;
    height: 28px;
  }

  .flight-select-hero-strip .flight-select-hero-airport-value-row,
  .flight-select-hero-strip .flight-select-hero-airport-value-row > div,
  .flight-select-hero-strip .flight-select-hero-date-value,
  .flight-select-hero-strip .flight-select-hero-option-dropdown,
  .flight-select-hero-strip .flight-search-strip-travelers-field .MuiOutlinedInput-root {
    height: 28px !important;
    min-height: 28px !important;
    max-height: 28px !important;
  }

  .flight-select-hero-strip .flight-select-hero-airport-value,
  .flight-select-hero-strip .flight-select-hero-date-value,
  .flight-select-hero-strip .flight-search-strip-travelers-field .MuiInputBase-input {
    line-height: 28px !important;
    height: 28px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    display: flex;
    align-items: center;
  }

  .flight-select-hero-strip .flight-select-hero-date-value {
    padding: 0 !important;
    margin: 0 !important;
    text-align: left !important;
    align-self: flex-start;
    width: 100%;
  }

  .flight-select-hero-strip .flight-select-hero-airport-value,
  .flight-select-hero-strip .MuiAutocomplete-input,
  .flight-select-hero-strip .MuiInputBase-input {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .flight-select-hero-strip .flight-select-hero-search-btn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: 0 !important;
    overflow: visible;
    flex: unset !important;
    width: auto;
    min-width: 0;
  }
}

@media (max-width: 899.98px) {
  .flight-search-strip-dates-row {
    width: 100%;
    flex: 1 1 100%;
    border-bottom: 1px solid #E8E9ED;
  }

  .flight-search-strip-dates-row > .flight-search-strip-date-field {
    border-bottom: none !important;
  }
}

.mobile-date-fullscreen-summary-box.single {
  flex: 1 1 100%;
}

/* ── MobileSearchDateSheet: fixed weekday header row (outside scroll) ── */
.mobile-date-sheet-weekday-row {
  display: flex;
  flex-shrink: 0;
  justify-content: space-around;
  align-items: center;
  padding: 4px 12px 8px;
  background: #fbfbfb;
  box-sizing: border-box;
}

.mobile-date-sheet-weekday-cell {
  flex: 1 1;
  text-align: center;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #434151;
  letter-spacing: 0;
  line-height: 16px;
}

/* Hide per-month day-name rows inside the fullscreen datepicker (we show our own fixed row) */
.mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day-names {
  display: none !important;
}

/* Hide navigation arrows (< >) — months scroll vertically, no paging */
.mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__navigation {
  display: none !important;
}

/* Month heading: clean centered text, no background */
.mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__header {
  background: transparent !important;
  border-bottom: none !important;
  padding-top: 8px;
  padding-bottom: 4px;
}

.mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__current-month,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__current-month {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
  font-size: 20px !important;
  font-weight: 700 !important;
  color: #252637 !important;
  text-align: center !important;
  padding: 12px 0 8px !important;
  line-height: 28px !important;
  letter-spacing: 0 !important;
  margin: 0 !important;
}

/* Mobile date sheet (FlightForm isMobile — below MUI md / 900px): selected / range ends — #CF2048, beats GlobalStyles + inline fare colors */
@media (max-width: 899.98px) {
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--selected,
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--selected:hover {
    background-color: #cf2048 !important;
    background: #cf2048 !important;
    color: #fff !important;
    border-radius: 3px !important;
    font-weight: 700 !important;
  }

  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--keyboard-selected.react-datepicker__day--selected,
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--keyboard-selected.react-datepicker__day--selected:hover {
    background-color: #cf2048 !important;
    background: #cf2048 !important;
    color: #fff !important;
  }

  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start,
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-end,
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start:hover,
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-end:hover {
    background-color: #cf2048 !important;
    background: #cf2048 !important;
    color: #fff !important;
    border-radius: 3px !important;
    font-weight: 700 !important;
  }

  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range,
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--in-range,
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-end.react-datepicker__day--in-range {
    background-color: #cf2048 !important;
    background: #cf2048 !important;
    color: #fff !important;
  }

  /* Figma range band — #FFDEE5 at ~56% opacity between departure and return endpoints */
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end),
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
    background-color: rgba(255, 222, 229, 0.56) !important;
    color: #434151 !important;
    border-radius: 0 !important;
  }

  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start:not(.react-datepicker__day--range-end) {
    border-radius: 3px 0 0 3px !important;
  }

  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-end:not(.react-datepicker__day--range-start) {
    border-radius: 0 3px 3px 0 !important;
  }

  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--range-end {
    border-radius: 3px !important;
  }

  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--selected[style],
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start[style],
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-end[style] {
    background-color: #cf2048 !important;
    background: #cf2048 !important;
    color: #fff !important;
  }

  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--selected > div > span:first-child,
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start > div > span:first-child,
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-end > div > span:first-child {
    color: #fff !important;
  }

  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--selected > div > span:last-child,
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start > div > span:last-child,
  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-end > div > span:last-child {
    color: rgba(255, 255, 255, 0.92) !important;
  }
}

/* ── Mobile Search Date sheet (Figma 6544:98832) — grid + range colors beat Homepage GlobalStyles ── */
[data-mobile-date-sheet] .mobile-fullscreen-datepicker.custom-datepicker-single-month .react-datepicker__month {
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
}

[data-mobile-date-sheet] .mobile-fullscreen-datepicker.custom-datepicker-single-month .react-datepicker__week {
  display: grid !important;
  grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
  width: 100% !important;
  margin: 0 0 6px !important;
  column-gap: 0 !important;
}

[data-mobile-date-sheet] .mobile-fullscreen-datepicker.custom-datepicker-single-month .react-datepicker__day {
  width: 100% !important;
  max-width: none !important;
  min-width: 0 !important;
  height: auto !important;
  min-height: 48px !important;
  margin: 2px 0 !important;
  padding: 6px 2px !important;
  box-sizing: border-box !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 20px !important;
  color: #434151 !important;
  border-radius: 0 !important;
}

[data-mobile-date-sheet] .mobile-fullscreen-datepicker.custom-datepicker-single-month .react-datepicker__day--disabled {
  color: #ccc !important;
  cursor: not-allowed !important;
  background: transparent !important;
  background-color: transparent !important;
}

/* Round-trip endpoints — #CF2048 (beats GlobalStyles #ab2645 + inline styles) */
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-end,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start:hover,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-end:hover,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--in-range,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-end.react-datepicker__day--in-range,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--selected,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--selected.react-datepicker__day--range-start,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start[style],
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-end[style],
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--selected[style] {
  background-color: #cf2048 !important;
  background: #cf2048 !important;
  color: #fff !important;
  font-weight: 700 !important;
}

[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start:not(.react-datepicker__day--range-end) {
  border-radius: 3px 0 0 3px !important;
}

[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-end:not(.react-datepicker__day--range-start) {
  border-radius: 0 3px 3px 0 !important;
}

[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--range-end {
  border-radius: 3px !important;
}

/* Pink range band — #FFDEE5 ~56% */
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end),
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end):hover,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end),
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end):hover {
  background-color: rgba(255, 222, 229, 0.56) !important;
  background: rgba(255, 222, 229, 0.56) !important;
  color: #434151 !important;
  border-radius: 0 !important;
}

[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end)[style],
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end)[style] {
  background-color: rgba(255, 222, 229, 0.56) !important;
  background: rgba(255, 222, 229, 0.56) !important;
}

[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start > div > span:first-child,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-end > div > span:first-child,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--selected > div > span:first-child {
  color: #fff !important;
}

[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start > div > span:last-child,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-end > div > span:last-child,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--selected > div > span:last-child {
  color: rgba(255, 255, 255, 0.92) !important;
}

/* Desktop flight calendar — same theme red as the mobile date sheet */
@media (min-width: 900px) {
  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--selected,
  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--selected:hover,
  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-start,
  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-end,
  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-start:hover,
  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-end:hover,
  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-start.react-datepicker__day--selected,
  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-start.react-datepicker__day--in-range,
  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-end.react-datepicker__day--in-range,
  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--selected[style],
  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-start[style],
  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-end[style] {
    background-color: #CF2048 !important;
    background: #CF2048 !important;
    color: #fff !important;
  }

  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end),
  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
    background-color: rgba(255, 222, 229, 0.56) !important;
    background: rgba(255, 222, 229, 0.56) !important;
    color: #434151 !important;
  }
}

[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) > div > span:first-child,
[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) > div > span:first-child {
  color: #434151 !important;
}

[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--selected):not(.react-datepicker__day--in-range):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
  background: transparent !important;
  color: #434151 !important;
}

.fare-date-calendar {
  width: 100%;
}

.fare-date-month-title {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #252637;
  text-align: center;
  padding: 12px 0 8px;
  margin: 0;
  line-height: 28px;
}

.fare-date-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  width: 100%;
  margin: 0 0 6px;
}

.fare-date-pad,
.fare-date-cell {
  min-height: 48px;
  margin: 2px 0;
  box-sizing: border-box;
}

.fare-date-cell {
  appearance: none;
  border: 0;
  background: transparent;
  width: 100%;
  padding: 6px 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #434151;
  border-radius: 0;
  cursor: pointer;
}

.fare-date-cell:disabled {
  color: #c5c5c5;
  cursor: default;
}

.fare-date-cell-price {
  font-size: 9px;
  font-weight: 600;
  margin-top: 1px;
  line-height: 1.1;
  white-space: nowrap;
}

.fare-date-cell--selected,
.fare-date-cell--range-single,
.fare-date-cell--range-start,
.fare-date-cell--range-end {
  background: #cf2048;
  color: #fff;
  font-weight: 700;
}

.fare-date-cell--selected,
.fare-date-cell--range-single {
  border-radius: 3px;
}

.fare-date-cell--range-start {
  border-radius: 3px 0 0 3px;
}

.fare-date-cell--range-end {
  border-radius: 0 3px 3px 0;
}

.fare-date-cell--in-range {
  background: rgba(255, 222, 229, 0.56);
  color: #434151;
}

.fare-date-cell--selected .fare-date-cell-price,
.fare-date-cell--range-single .fare-date-cell-price,
.fare-date-cell--range-start .fare-date-cell-price,
.fare-date-cell--range-end .fare-date-cell-price {
  color: rgba(255, 255, 255, 0.92) !important;
}

.mobile-sheet-field {
  display: flex;
  align-items: center;
  gap: 0;
  width: 100%;
  height: 56px;
  min-height: 56px;
  max-height: 56px;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: #f3f3f7;
  box-sizing: border-box;
  cursor: text;
  -webkit-tap-highlight-color: transparent;
}

.mobile-sheet-field-inner {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

/* Scoped under sheet — Figma 6544:98010 / 6544:98016 */
.mobile-airport-sheet .mobile-sheet-field:not(.active) {
  border: 1px solid transparent !important;
  background: #f3f3f7 !important;
  box-shadow: none !important;
  outline: none !important;
}

.mobile-airport-sheet .mobile-sheet-field.active,
.mobile-airport-sheet .mobile-sheet-field.active:focus-within {
  border: 1px solid #252637 !important;
  background: #f3f3f7 !important;
  box-shadow: none !important;
  outline: none !important;
}

.mobile-sheet-field-label,
.mobile-sheet-field-label.MuiTypography-root {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.25px;
  color: #535462;
  margin: 0;
  padding: 0;
  display: block;
}

.mobile-sheet-field-selected {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
  margin-top: 0;
}

.mobile-sheet-field-code-city {
  flex-shrink: 0;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: #1a1827;
}

.mobile-sheet-field-airport-name {
  flex: 1 1;
  min-width: 0;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.15px;
  color: #535462;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-sheet-input {
  display: block;
  width: 100%;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: #1a1827;
  padding: 0;
  margin: 0;
  appearance: none;
  -webkit-text-fill-color: #1a1827;
  box-shadow: none;
}

/* Active typing — Figma 6544:98019: semibold 16 / 22 */
.mobile-airport-sheet .mobile-sheet-field.active .mobile-sheet-input,
.mobile-airport-sheet .mobile-sheet-field.active .mobile-sheet-input:focus {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #1a1827;
  -webkit-text-fill-color: #1a1827;
  outline: none;
  box-shadow: none;
  border: none;
}

.mobile-sheet-input::placeholder {
  color: #717180;
  opacity: 1;
  font-weight: 400;
  -webkit-text-fill-color: #717180;
}

.mobile-airport-sheet .mobile-sheet-field.active .mobile-sheet-input::placeholder {
  color: #717180;
  font-weight: 400;
  -webkit-text-fill-color: #717180;
}

.mobile-sheet-field-clear {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 4px;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--yovo-grey-700, #686A7A);
  -webkit-tap-highlight-color: transparent;
}

.mobile-sheet-field-clear:active {
  opacity: 0.7;
}

.mobile-sheet-results {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
  touch-action: pan-y;
  padding: 0 16px max(0.5rem, env(safe-area-inset-bottom, 0px));
}

@media (max-width: 899.98px) {
  .mobile-airport-sheet.open.is-keyboard-open .mobile-sheet-results {
    gap: 1rem;
    padding-bottom: 12px;
  }
}

.mobile-sheet-separator {
  display: inline-flex !important;
  align-items: center;
  align-self: flex-start;
  width: fit-content !important;
  padding: 3px 10px !important;
  margin: 0 !important;
  background: #eef0fb !important;
  color: #4e5694 !important;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 18px !important;
  border-radius: 6px;
  pointer-events: none;
  box-sizing: border-box;
}

.mobile-sheet-option {
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  padding: 0;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
  width: 100%;
}

.mobile-sheet-option:active {
  background: #f5f5f7;
}

/* ===============================================
   Mobile Travellers & Class — full-screen modal (viewport < 768px; opened from JS)
   Uses 100dvh (not 100vh) for iOS browser chrome; safe-area insets on header/footer
   =============================================== */
.mobile-travellers-sheet-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1350;
  background: rgba(32, 32, 42, 0.45);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.22s ease, visibility 0.22s ease;
  -webkit-tap-highlight-color: transparent;
}

.mobile-travellers-sheet-backdrop.open {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.mobile-travellers-sheet {
  position: fixed;
  inset: 0;
  z-index: 1351;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  /* Full viewport height — dvh avoids iOS 100vh bugs; fallback for older browsers */
  min-height: 100vh;
  min-height: 100dvh;
  height: 100vh;
  height: 100dvh;
  max-height: 100vh;
  max-height: 100dvh;
  background: #fff;
  border-radius: 0;
  box-shadow: none;
  transform: translate3d(0, 100%, 0);
  transition: transform 0.3s cubic-bezier(0.32, 0.72, 0, 1);
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
}

.mobile-travellers-sheet.open {
  transform: translate3d(0, 0, 0);
}

.mobile-travellers-sheet-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding-top: max(0.5rem, env(safe-area-inset-top, 0px));
  padding-left: max(1rem, env(safe-area-inset-left, 0px));
  padding-right: max(1rem, env(safe-area-inset-right, 0px));
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e8e9ed;
  box-sizing: border-box;
}

.mobile-travellers-sheet-section-label {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: clamp(0.9375rem, 4vw, 1rem);
  font-weight: 700;
  color: #20202a;
  margin: 0 0 1rem 0;
  line-height: 1.3;
}

.mobile-travellers-sheet-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
  touch-action: pan-y;
  padding-top: 1rem;
  padding-bottom: 1.25rem;
  padding-left: max(clamp(1rem, 5vw, 1.25rem), env(safe-area-inset-left, 0px));
  padding-right: max(clamp(1rem, 5vw, 1.25rem), env(safe-area-inset-right, 0px));
  box-sizing: border-box;
}

.mobile-travellers-section {
  margin-bottom: 1.25rem;
}

.mobile-travellers-section-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 0.625rem;
}

.mobile-travellers-section-title {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-weight: 700;
  font-size: clamp(0.875rem, 3.8vw, 0.9375rem);
  color: #20202a;
}

.mobile-travellers-section-hint {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 0.75rem;
  color: var(--yovo-grey-700, #686A7A);
  flex-shrink: 0;
}

.mobile-travellers-num-row {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;
  padding-bottom: 0.25rem;
  scrollbar-width: none;
}

.mobile-travellers-num-row::-webkit-scrollbar {
  display: none;
}

.mobile-travellers-num-chip {
  flex: 0 0 auto;
  min-width: 2.75rem;
  min-height: 2.75rem;
  padding: 0 0.35rem;
  border-radius: 0.5rem;
  border: 1px solid transparent;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  background: #fff;
  color: #20202a;
  box-sizing: border-box;
}

.mobile-travellers-num-chip--active {
  background: #c62842;
  border-color: #c62842;
  color: #fff;
}

.mobile-travellers-num-chip:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.mobile-travellers-class-heading {
  display: block;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-weight: 700;
  font-size: clamp(0.875rem, 3.8vw, 0.9375rem);
  color: #20202a;
  margin-bottom: 0.625rem;
}

.mobile-travellers-class-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.mobile-travellers-class-chip {
  flex: 1 1 auto;
  min-width: min(42%, 9.5rem);
  padding: 0.65rem 0.75rem;
  border-radius: 0.625rem;
  border: none;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: clamp(0.8125rem, 3.2vw, 0.875rem);
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  background: #f5f5f7;
  color: #383a47;
  box-sizing: border-box;
}

.mobile-travellers-class-chip--active {
  background: #c62842;
  color: #fff;
}

.mobile-travellers-sheet-footer {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding-top: 0.75rem;
  padding-bottom: max(0.75rem, env(safe-area-inset-bottom, 0px));
  padding-left: max(clamp(1rem, 5vw, 1.25rem), env(safe-area-inset-left, 0px));
  padding-right: max(clamp(1rem, 5vw, 1.25rem), env(safe-area-inset-right, 0px));
  border-top: 1px solid #e8e9ed;
  background: #fff;
  box-sizing: border-box;
}

.mobile-travellers-sheet-footer-summary {
  flex: 1 1 auto;
  min-width: 0;
}

.mobile-travellers-sheet-footer-line1 {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: clamp(0.8125rem, 3.2vw, 0.875rem);
  font-weight: 700;
  color: #20202a;
  line-height: 1.35;
}

.mobile-travellers-sheet-footer-line2 {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  color: #aeaeb8;
  margin-top: 0.125rem;
  line-height: 1.35;
}

.mobile-travellers-sheet-save.MuiButton-root {
  flex: 0 0 auto;
  min-width: 6.5rem;
  padding: 0.65rem 1.25rem !important;
  border-radius: 0.875rem !important;
  text-transform: none !important;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  background-color: #20202a !important;
  color: #fbfbfb !important;
  box-shadow: none !important;
}

.mobile-travellers-sheet-save.MuiButton-root:hover {
  background-color: #383a47 !important;
  box-shadow: none !important;
}

/* Safe-area horizontal padding is applied on the sheet blocks above for all orientations */

/* ===============================================
   Passenger/Traveler Dropdown
   =============================================== */

.passenger-dropdown {
  -webkit-tap-highlight-color: transparent;
  text-size-adjust: 100%;
}

.passenger-dropdown-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 2px;
}

.passenger-dropdown-title {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  color: #16161D;
}

.passenger-dropdown-subtitle {
  margin-top: 0;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #8B8D98;
}

.passenger-dropdown-reset {
  margin: 0;
  padding: 2px 0;
  border: 0;
  background: transparent;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #8B8D98;
  cursor: pointer;
}

.passenger-dropdown-reset:hover {
  color: #20202A;
}

.passenger-dropdown-rows {
  display: flex;
  flex-direction: column;
}

.passenger-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
  border-top: 1px solid #F0F1F5;
}

.passenger-row:first-child {
  border-top: 0;
}

.passenger-row--locked {
  opacity: 0.45;
}

.passenger-row-title {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: #16161D;
}

.passenger-row-hint {
  margin-top: 0;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: #8B8D98;
}

.passenger-row-note {
  margin-top: 2px;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 11px;
  line-height: 14px;
  color: #E65100;
}

.passenger-stepper {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  background: #F4F5F8;
  border-radius: 999px;
  padding: 3px;
}

.passenger-stepper-btn {
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
}

.passenger-stepper-btn--minus {
  background: #FFFFFF;
  color: #20202A;
  box-shadow: 0 1px 2px rgba(22, 22, 29, 0.08);
}

.passenger-stepper-btn--plus {
  background: #16161D;
  color: #FFFFFF;
}

.passenger-stepper-btn:hover:not(:disabled) {
  filter: brightness(0.96);
}

.passenger-stepper-btn:disabled {
  background: #E6E7ED;
  color: #C5C6CE;
  box-shadow: none;
  cursor: not-allowed;
}

.passenger-stepper-value {
  min-width: 20px;
  text-align: center;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  color: #16161D;
}

.passenger-stepper-value--empty {
  color: #B0B2BC;
  font-weight: 600;
}

.passenger-dropdown-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 2px;
  padding: 6px 10px;
  background: #F7F8FA;
  border: 1px solid #ECEEF3;
  border-radius: 10px;
}

.passenger-dropdown-summary-count {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  color: #4E5160;
}

.passenger-dropdown-summary-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1.5px solid #9A9CAA;
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;
}

.passenger-dropdown-summary-dot::after {
  content: '';
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #9A9CAA;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.passenger-dropdown-summary-max {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  color: #8B8D98;
}

/* Homepage AI mascot must not bleed through the desktop travellers dropdown */
body[data-passenger-dropdown-open] .homepage-ai-travel-guide-mascot {
  visibility: hidden;
  pointer-events: none;
}

.passenger-dropdown-label {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 20px !important;
  letter-spacing: 0.4px !important;
  color: #545665 !important;
  white-space: nowrap;
}

.passenger-counter-bar {
  display: flex;
  align-items: center;
  gap: 24px;
  background: #E8E9ED;
  border-radius: 12px;
  padding: 4px;
  width: 100%;
  box-sizing: border-box;
}

.passenger-counter-btn {
  width: 20px !important;
  height: 22px !important;
  min-width: 25px !important;
  border-radius: 8px !important;
  background-color: #20202A !important;
  color: #FBFBFB !important;
  font-size: 1.125rem !important;
  font-weight: 600 !important;
  padding: 0 !important;
  line-height: 1 !important;
  -webkit-tap-highlight-color: transparent;
  appearance: none;
  transition: background-color 0.15s ease;
  flex-shrink: 0;
}

.passenger-counter-btn:hover {
  background-color: #383A47 !important;
}

.passenger-counter-btn.Mui-disabled {
  background-color: #C3C3CD !important;
  color: #F5F5F7 !important;
}

.passenger-counter-value {
  flex: 1 0;
  text-align: center !important;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 24px !important;
}

.passenger-done-btn {
  width: 100% !important;
  height: 40px !important;
  background-color: #16161D !important;
  color: #FFFFFF !important;
  border-radius: 12px !important;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  letter-spacing: 0.1px !important;
  line-height: 20px !important;
  text-transform: none !important;
  margin-top: 10px !important;
  padding: 6px 16px !important;
  box-shadow: none !important;
  -webkit-tap-highlight-color: transparent;
  appearance: none;
}

.passenger-done-btn:hover {
  background-color: #383A47 !important;
  box-shadow: none !important;
}

/* Mobile: ensure minimum tap targets */
@media (max-width: 899.98px) {
  .passenger-counter-btn {
    min-height: 44px !important;
    height: 44px !important;
    min-width: 44px !important;
    width: 44px !important;
  }

  .passenger-done-btn {
    min-height: 40px !important;
  }

  .passenger-counter-bar {
    gap: 16px;
    padding: 4px;
  }

  /* iOS input zoom prevention */
  .passenger-dropdown input {
    font-size: 16px !important;
    appearance: none;
  }
}

/* iOS safe area for landscape */
@supports (padding-left: env(safe-area-inset-left)) {
  @media (orientation: landscape) and (hover: none) and (pointer: coarse) {
    .passenger-dropdown {
      padding-left: max(16px, env(safe-area-inset-left));
      padding-right: max(16px, env(safe-area-inset-right));
    }
  }
}

/* ===============================================
   Class Dropdown
   =============================================== */

/* MUI Select Menu sets Paper minWidth to the anchor width (often full row). Force content-sized menu. */
.class-dropdown-paper.MuiPaper-root {
  min-width: min-content !important;
  width: max-content !important;
  max-width: min(100vw - 32px, 220px) !important;
  box-sizing: border-box;
}

.class-select-field {
  overflow: visible !important;
}

/* Flush left: label “Class” and value “Economy” share the same x-origin (MUI adds default pl on select) */
.class-select-field .MuiOutlinedInput-root {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.class-select-field .MuiSelect-select {
  overflow: visible !important;
  text-overflow: clip !important;
  white-space: nowrap !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  min-width: 0;
}

.class-select-field .MuiInputBase-input {
  overflow: visible !important;
  text-overflow: clip !important;
  padding-left: 0 !important;
}

.class-select-field .MuiOutlinedInput-root,
.class-select-field .MuiInputBase-root {
  overflow: visible !important;
}

.class-dropdown-item {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  line-height: 24px !important;
  color: #545665 !important;
  padding: 0 !important;
  min-height: auto !important;
  white-space: nowrap;
  background: transparent !important;
  -webkit-tap-highlight-color: transparent;
}

.class-dropdown-item:hover {
  color: #20202A !important;
  background: transparent !important;
}

.class-dropdown-item.Mui-selected {
  color: #20202A !important;
  background: transparent !important;
  font-weight: 700 !important;
}

.class-dropdown-item.Mui-selected:hover {
  background: transparent !important;
}

/* Mobile: ensure proper tap targets */
@media (max-width: 899.98px) {
  .class-dropdown-item {
    min-height: 44px !important;
    display: flex !important;
    align-items: center !important;
  }
}

/* ===============================================
   Special Fares — Fare Option Pills
   =============================================== */

.special-fare-pill-tooltip-trigger {
  display: inline-flex;
  max-width: 100%;
}

.special-fare-info-tooltip.MuiTooltip-tooltip {
  background-color: #fff;
  color: #20202A;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.15px;
  padding: 12px 14px;
  max-width: 280px;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(32, 32, 42, 0.12);
}

.special-fare-info-tooltip .MuiTooltip-arrow {
  color: #fff;
}

.special-fare-info-tooltip .MuiTooltip-arrow::before {
  box-shadow: 0 2px 8px rgba(32, 32, 42, 0.08);
}

/* Mobile: (i) tap → centered white info popover (same copy as desktop hover tooltip) */
.special-fare-info-sheet-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1410;
  background: rgba(32, 32, 42, 0.35);
}

.special-fare-info-sheet {
  position: fixed;
  inset: 0;
  z-index: 1411;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  padding-left: max(16px, env(safe-area-inset-left, 0px));
  padding-right: max(16px, env(safe-area-inset-right, 0px));
  pointer-events: none;
}

.special-fare-info-sheet-inner {
  position: relative;
  pointer-events: auto;
  width: 100%;
  max-width: 340px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(32, 32, 42, 0.12);
  padding: 14px 16px;
}

.fare-option-pill {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  border-radius: 12px;
  padding: 8px 12px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
  user-select: none;
}

.fare-option-radio {
  width: 20px;
  height: 20px;
  display: block;
  flex-shrink: 0;
}

.fare-option-title {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 20px !important;
  color: #20202A !important;
  white-space: nowrap;
}

.fare-option-subtitle {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 16px !important;
  white-space: nowrap;
}

/* Mobile: compact fare pills, horizontal scroll */
@media (max-width: 899.98px) {
  .fare-option-pill {
    min-height: 36px;
    padding: 5px 10px;
    gap: 6px;
    border-radius: 8px;
  }

  .fare-option-radio {
    width: 14px;
    height: 14px;
  }

  .fare-option-title {
    font-size: 11px !important;
    line-height: 15px !important;
  }

  .fare-option-subtitle {
    font-size: 10px !important;
    line-height: 13px !important;
  }

  .special-fares-options {
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x proximity;
    padding-bottom: 4px;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .special-fares-options > div {
    scroll-snap-align: start;
    flex-shrink: 0;
  }
}


/* ===============================================
   Date Picker — Responsive (mobile compact)
   =============================================== */
@media (max-width: 899.98px) {
  .custom-datepicker-single-month {
    display: flex !important;
    flex-direction: column !important;
    gap: 4px !important;
    width: 100% !important;
    max-width: 100vw;
    font-size: 13px;
  }

  .custom-datepicker-single-month .react-datepicker__month-container {
    width: 100% !important;
    float: none !important;
  }

  .custom-datepicker-single-month .react-datepicker__header {
    padding-top: 6px;
    padding-bottom: 4px;
    font-size: 13px;
  }

  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__current-month {
    font-size: 14px !important;
    margin-bottom: 4px;
  }

  .custom-datepicker-single-month .react-datepicker__day-names {
    margin-bottom: 0;
  }

  .custom-datepicker-single-month .react-datepicker__day-name {
    width: 2rem;
    line-height: 1.8rem;
    font-size: 12px;
    margin: 1px;
  }

  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day {
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    font-size: 13px;
    margin: 1px;
    -webkit-tap-highlight-color: transparent;
  }

  .custom-datepicker-single-month .react-datepicker__navigation {
    top: 6px;
  }
}


/* ===============================================
   Airport Dropdown — Responsive Popper (compact)
   =============================================== */
@media (max-width: 899.98px) {
  .MuiAutocomplete-popper {
    left: 16px !important;
    right: 16px !important;
    width: calc(100vw - 32px) !important;
  }

  .flight-dropdown-search-bar {
    padding: 8px 10px;
    gap: 10px;
    border-radius: 10px;
  }

  .flight-dropdown-search-input {
    font-size: 14px;
    line-height: 20px;
  }

  .flight-dropdown-option {
    padding: 8px 12px;
    min-height: 40px;
    -webkit-tap-highlight-color: transparent;
  }

  .flight-dropdown-option-city {
    font-size: 14px;
    line-height: 20px;
  }

  .flight-dropdown-option-airport {
    font-size: 12px;
    line-height: 16px;
  }

  .flight-dropdown-option-code {
    font-size: 13px;
    margin-left: 8px;
  }

  .flight-dropdown-option-icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
    margin-top: 0 !important;
  }

  .flight-dropdown-separator {
    font-size: 11px !important;
    padding: 3px 6px !important;
    margin: 4px 12px !important;
  }
}


/* ===============================================
   Passenger Dropdown — Compact mobile
   =============================================== */
@media (max-width: 899.98px) {
  .passenger-dropdown {
    border-radius: 14px !important;
  }

  .passenger-dropdown-label {
    font-size: 13px !important;
    line-height: 18px !important;
  }

  .passenger-counter-bar {
    gap: 16px;
    padding: 4px;
    border-radius: 10px;
  }

  .passenger-counter-value {
    font-size: 14px !important;
    line-height: 20px !important;
  }

  .passenger-done-btn {
    height: 40px !important;
    font-size: 14px !important;
    border-radius: 10px !important;
    margin-top: 10px !important;
  }
}

/* ===============================================
   Class Dropdown — Compact mobile
   =============================================== */
@media (max-width: 899.98px) {
  .class-dropdown-paper.MuiPaper-root {
    border-radius: 12px !important;
  }

  .class-dropdown-item {
    font-size: 14px !important;
    line-height: 20px !important;
    min-height: 40px !important;
  }
}

@media (max-width: 899.98px) {
  /* Mobile checkboxes section */
  .flight-form-mobile-checkboxes {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 12px;
    padding-top: 4px;
  }

  .flight-form-mobile-checkbox-row {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    min-height: 44px;
  }

  .flight-form-mobile-checkbox-img {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  .flight-form-mobile-checkbox-label {
    font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
    font-size: 13px !important;
    font-weight: 400;
    color: #20202A;
  }
}

/* ===============================================
   Multi-city homepage row — Figma desktop 2819:86711
   + mobile reference (From | To | Date + trash).
   Mirrors ExpandedMulticityForm.fs-emc-* patterns without importing
   flight_select CSS (keeps homepage self-contained).
   Swap control: Figma node 2819:182406 — use .flight-form-swap everywhere.
   =============================================== */

.flight-mc-remove {
  flex-shrink: 0;
  margin-left: clamp(12px, 1.5vw, 20px);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.1875rem;
  color: var(--neutrals-grey-800, #545665);
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  align-self: center;
  min-width: 56px;
  text-align: left;
  transition: color 0.2s ease;
}
.flight-mc-remove:hover {
  color: #ce001f;
  text-decoration: underline;
}
.flight-mc-remove:active {
  background: none;
  outline: none;
  color: var(--neutrals-grey-800, #545665);
  text-decoration: none;
}
.flight-mc-remove:focus:not(:focus-visible) {
  outline: none;
}
.flight-mc-remove:focus-visible {
  outline: 2px solid rgba(32, 32, 42, 0.4);
  outline-offset: 2px;
  border-radius: 4px;
}
.flight-mc-remove[data-disabled='true'] {
  visibility: hidden;
  pointer-events: none;
}

.flight-mc-add-stop {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 48px;
  margin-top: 12px;
  margin-bottom: 4px;
  background: var(--Neutrals-grey-200, #e8e9ed);
  border-radius: 16px;
  cursor: pointer;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.1875rem;
  color: var(--Neutrals-base-black, #20202a);
  border: none;
  padding: 6px 16px;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  transition: background-color 0.2s ease;
}
.flight-mc-add-stop:hover {
  background: var(--Neutrals-grey-300, #d6d9e0);
}

/* Mobile multicity — Figma 3888:47152 */
.flight-mc-add-stop--mobile {
  gap: 0;
  min-height: 0;
  margin-top: 0;
  margin-bottom: 0;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.25px;
}

/* Two-tone airport line (desktop); sits over transparent Autocomplete input */
.flight-mc-airport-overlay {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  pointer-events: none;
  z-index: 1;
  min-height: 28px;
}
.flight-mc-airport-overlay--mobile {
  align-items: flex-start;
  justify-content: center;
  padding-top: 6px;
}
.flight-mc-display-city {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  line-height: 22px;
  color: var(--Neutrals-base-black, #20202a);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.flight-mc-display-iata {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 1rem;
  font-weight: 500;
  line-height: 22px;
  color: var(--Neutrals-grey-700, var(--yovo-grey-700, #686A7A));
  flex-shrink: 0;
}
.flight-mc-display-placeholder {
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 1rem;
  font-weight: 500;
  line-height: 22px;
  color: var(--Neutrals-grey-700, var(--yovo-grey-700, #686A7A));
}
`, "",{"version":3,"sources":["webpack://./src/components/Homepage/styles/FlightForm.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,0CAA0C;AAC1C;;;;;EAKE,wCAAwC;EAExC,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EAEE,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;oDAEoD;AACpD;EACE;IACE,kBAAkB;EACpB;;EAEA;;;IAGE;EACF;IACE,uBAAuB;EACzB;;EAEA;;;;;IAKE,2BAA2B;EAC7B;;EAEA;;IAEE,gBAAgB;IAChB,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;;;IAGE,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;;;;;IAKE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;;;;;;IAME,2BAA2B;IAC3B,uBAAuB;IACvB,4BAA4B;IAC5B,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA,gFAAgF;EAChF;IACE,sBAAsB;IACtB,eAAe;EACjB;AACF;;;AAGA;;oDAEoD;AACpD;EACE,sEAAsE;EACtE;IACE,8BAA8B;IAC9B,0BAA0B;IAC1B,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;IAC3B,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA,kFAAkF;EAClF;IACE,6BAA6B;IAE7B,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,8BAA8B;IAC9B,4BAA4B;IAC5B,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,wBAAwB;IACxB,+BAA+B;EACjC;;EAEA,iFAAiF;EACjF;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,cAAc;IACd,gCAAgC;IAChC,sBAAsB;EACxB;;EAEA;IACE,SAAW;IACX,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA,mFAAmF;EACnF;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,uGAAuG;AACvG;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,+CAA+C;EAC/C,mDAAmD;EACnD,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,sCAAsC;EACtC,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,6CAA6C;EAC7C,UAAU;EACV,oBAAoB;AACtB;;AAEA,+FAA+F;AAC/F;EACE;IACE,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,gCAAgC;IAChC,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA,yEAAyE;EACzE;IACE,aAAa;EACf;AACF;;AAEA;EACE,sFAAsF;EACtF;IACE,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA,4FAA4F;EAC5F;;;;IAIE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;IAC5B,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;;IAEE,qBAAqB;IACrB,4BAA4B;IAC5B,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;IACrB,4BAA4B;IAC5B,uBAAuB;EACzB;AACF;;AAEA,gEAAgE;AAChE;EACE;IACE;MACE,uCAAuC;MACvC,yCAAyC;IAC3C;EACF;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,iCAAiC;EACnC;AACF;;;AAGA;;oDAEoD;;AAEpD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,YAAY;EAEZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,iGAAiG;EACjG,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,oBAAoB;EACpB,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;EAC7B,uCAAuC;EACvC,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,iGAAiG;EACjG,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iGAAiG;EACjG,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;AACF;;;AAGA;;;oDAGoD;AACpD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,qDAAqD;EACrD,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,mGAAmG;AACnG;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,kCAAkC;EAClC,0DAA0D;EAC1D,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA,oEAAoE;AACpE;EACE;IACE,iBAAiB;IACjB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,8BAA8B;IAC9B,6EAA6E;IAC7E,4BAA4B;IAC5B,wCAAwC;IACxC,mBAAmB;IACnB,cAAc;IACd,gDAAgD;EAClD;;EAEA,kFAAkF;EAClF;IACE,yCAAyC;IACzC,uCAAuC;IACvC,aAAa;IACb,2CAA2C;IAC3C,iBAAiB;EACnB;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,2FAA2F;AAC3F;EACE,cAAc;AAChB;;AAEA,2FAA2F;AAC3F;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,qDAAqD;EACrD,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;EACpB;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,2DAA2D;AAC7D;;AAEA,yEAAyE;AACzE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,qFAAqF;AACrF;EACE;IACE,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;IAC1C,gDAAgD;EAClD;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,iGAAiG;EACjG,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,2DAA2D;EAC3D,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,wCAAwC;EACxC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;EAGE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,WAAW;EACX,wCAAwC;EACxC,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;EAGE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,wDAAwD;AAC1D;;AAEA,sEAAsE;AACtE;;;;;;;;;;EAUE,oCAAoC;EACpC,8BAA8B;EAC9B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;EAEE,wCAAwC;EACxC,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,8EAA8E;AAC9E;;;;EAIE,oCAAoC;EACpC,8BAA8B;EAC9B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;EAEE,wCAAwC;EACxC,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,4GAA4G;EAC5G,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAW;EACX,YAAY;AACd;;AAEA,kFAAkF;AAClF;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;;IAEE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA,sGAAsG;AACtG;EACE;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,WAAa;IACb,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,SAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAa;IACb,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,SAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA;EACE;;;;IAIE;EACF;IACE,wBAAwB;IACxB,kBAAkB;IAClB,iCAAiC;IACjC,WAAW;IACX,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE;;;;UAIM;EACR;;EAEA;IACE;;;;UAIM;EACR;;EAEA,qEAAqE;EACrE;IACE;;;;UAIM;EACR;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA,+CAA+C;EAC/C;IACE,wBAAwB;IACxB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,MAAM;EACR;;EAEA;IACE,SAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;;IAGE;EACF;;IAEE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;;;;IAKE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,gDAAgD;IAChD,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB,8BAA8B;IAC9B,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,oBAAoB;EACtB;;EAEA,0EAA0E;EAC1E;IACE,yBAAyB;IACzB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,eAAe;IACf,SAAS;IACT,gCAAgC;IAChC,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,0BAA0B;IAC1B,uDAAuD;EACzD;;EAEA;;;;IAIE,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;;;;IAIE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;EACd;;EAEA;;;;;IAKE,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;;;IAGE,4BAA4B;IAC5B,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;IACpB,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;EACb;;EAEA;;;IAGE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAW;EACX,kBAAkB;EAClB,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,8FAA8F;AAC9F;EACE,wBAAwB;AAC1B;;AAEA,uEAAuE;AACvE;EACE,wBAAwB;AAC1B;;AAEA,sDAAsD;AACtD;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,4GAA4G;EAC5G,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA,6IAA6I;AAC7I;EACE;;IAEE,oCAAoC;IACpC,8BAA8B;IAC9B,sBAAsB;IACtB,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;;IAEE,oCAAoC;IACpC,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;;;;IAIE,oCAAoC;IACpC,8BAA8B;IAC9B,sBAAsB;IACtB,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;;;IAGE,oCAAoC;IACpC,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA,sFAAsF;EACtF;;IAEE,sDAAsD;IACtD,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,oCAAoC;IACpC,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;;;IAGE,sBAAsB;EACxB;;EAEA;;;IAGE,2CAA2C;EAC7C;AACF;;AAEA,uGAAuG;AACvG;EACE,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,2DAA2D;EAC3D,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA,gFAAgF;AAChF;;;;;;;;;;;;EAYE,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,mCAAmC;AACnC;;;;EAIE,sDAAsD;EACtD,gDAAgD;EAChD,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,sDAAsD;EACtD,gDAAgD;AAClD;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA,sEAAsE;AACtE;EACE;;;;;;;;;;;;IAYE,oCAAoC;IACpC,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;;IAEE,sDAAsD;IACtD,gDAAgD;IAChD,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;;;EAIE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,uDAAuD;AACvD;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;EAEE,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;EAEE,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,SAAS;EAET,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;AACF;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;EAC5B,oBAAoB;EACpB,8BAA8B;EAC9B,yBAAyB;EACzB,iGAAiG;EACjG,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,eAAe;EACf,wCAAwC;EACxC,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;oDAGoD;AACpD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,qDAAqD;EACrD,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kFAAkF;EAClF,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,yDAAyD;EACzD,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uDAAuD;EACvD,uDAAuD;EACvD,yDAAyD;EACzD,uBAAuB;EACvB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,iGAAiG;EACjG,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,4EAA4E;EAC5E,8EAA8E;EAC9E,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,iGAAiG;EACjG,gBAAgB;EAChB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,iGAAiG;EACjG,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iGAAiG;EACjG,gBAAgB;EAChB,4CAA4C;EAC5C,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,iGAAiG;EACjG,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;EACpB,8DAA8D;EAC9D,4EAA4E;EAC5E,8EAA8E;EAC9E,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iGAAiG;EACjG,4CAA4C;EAC5C,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iGAAiG;EACjG,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,4GAA4G;EAC5G,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,2FAA2F;;AAE3F;;oDAEoD;;AAEpD;EACE,wCAAwC;EAExC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iGAAiG;EACjG,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,4GAA4G;EAC5G,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;EAExC,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,SAAW;EACX,6BAA6B;EAC7B,4GAA4G;EAC5G,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,8BAA8B;EAC9B,4GAA4G;EAC5G,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;EAChC,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,wCAAwC;EAExC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,uCAAuC;AACvC;EACE;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,SAAS;IACT,YAAY;EACd;;EAEA,8BAA8B;EAC9B;IACE,0BAA0B;IAE1B,gBAAgB;EAClB;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE;MACE,kDAAkD;MAClD,oDAAoD;IACtD;EACF;AACF;;AAEA;;oDAEoD;;AAEpD,wGAAwG;AACxG;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,0GAA0G;AAC1G;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,4GAA4G;EAC5G,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sCAAsC;AACtC;EACE;IACE,2BAA2B;IAC3B,wBAAwB;IACxB,8BAA8B;EAChC;AACF;;AAEA;;oDAEoD;;AAEpD;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,uFAAuF;AACvF;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uDAAuD;EACvD,yDAAyD;EACzD,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,wCAAwC;EACxC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,4GAA4G;EAC5G,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,4GAA4G;EAC5G,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,iCAAiC;IACjC,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,cAAc;EAChB;AACF;;;AAGA;;oDAEoD;AACpD;EACE;IACE,wBAAwB;IACxB,iCAAiC;IACjC,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,wCAAwC;EAC1C;;EAEA;IACE,QAAQ;EACV;AACF;;;AAGA;;oDAEoD;AACpD;EACE;IACE,qBAAqB;IACrB,sBAAsB;IACtB,oCAAoC;EACtC;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;EAC1C;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;;AAGA;;oDAEoD;AACpD;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,SAAS;IACT,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,8BAA8B;IAC9B,2BAA2B;EAC7B;AACF;;AAEA;;oDAEoD;AACpD;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;EAC7B;AACF;;AAEA;EACE,8BAA8B;EAC9B;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,wCAAwC;IACxC,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,iGAAiG;IACjG,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;;;;;;oDAMoD;;AAEpD;EACE,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iGAAiG;EACjG,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC;EACxC,wCAAwC;EACxC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,wCAAwC;EACxC,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,mBAAmB;EACnB,eAAe;EACf,iGAAiG;EACjG,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,wCAAwC;EACxC,0BAA0B;EAC1B,sCAAsC;AACxC;AACA;EACE,6CAA6C;AAC/C;;AAEA,wCAAwC;AACxC;EACE,MAAM;EACN,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,8DAA8D;EAC9D,cAAc;AAChB;AACA;EACE,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,8DAA8D;AAChE","sourcesContent":["/* FlightForm - Responsive Styles\n * Matches MUI theme defaults: xs 0–599, sm 600–899, md 900+.\n * Mobile/tablet UI (bottom sheets, compact strip): max-width 899.98px — same as `theme.breakpoints.down('md')`.\n * Desktop: min-width 900px — `theme.breakpoints.up('md')`.\n */\n\n/* ===== Base resets (all devices) ===== */\n.special-fares-row,\n.special-fares-slider-wrap,\n.special-fares-options,\n.flight-tracker-btn,\n.flight-search-strip {\n  -webkit-tap-highlight-color: transparent;\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n  box-sizing: border-box;\n}\n\n.flight-search-strip {\n  position: relative;\n}\n\n.special-fares-row {\n  width: 100%;\n  display: flex;\n  box-sizing: border-box;\n}\n\n.special-fares-slider-wrap {\n  width: 100%;\n}\n\n.flight-tracker-btn {\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n/* Horizontal fare “slider”: touch momentum + snap (no radio UI). */\n.special-fares-slider {\n  scroll-snap-type: x proximity;\n}\n\n.special-fares-options {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  display: flex;\n}\n\n.special-fares-options::-webkit-scrollbar {\n  display: none;\n}\n\n.special-fares-options > div {\n  -webkit-tap-highlight-color: transparent;\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n/* ===============================================\n   DESKTOP (md / 900px+) — layout from JSX\n   =============================================== */\n@media (min-width: 900px) {\n  .flight-search-strip input {\n    font-size: inherit;\n  }\n\n  /*\n   * Homepage FlightForm — one-way / round-trip desktop strip:\n   * one label row + one value row across From, To, dates, travelers, class.\n   */\n  .flight-search-strip--ow-rt {\n    align-items: flex-start;\n  }\n\n  .flight-search-strip--ow-rt > .flight-search-strip-airport-field,\n  .flight-search-strip--ow-rt > .flight-search-strip-date-field,\n  .flight-search-strip--ow-rt > .flight-search-strip-dates-row,\n  .flight-search-strip--ow-rt > .flight-search-strip-travelers-field,\n  .flight-search-strip--ow-rt > .flight-search-strip-class-field {\n    justify-content: flex-start;\n  }\n\n  .flight-search-strip--ow-rt .flight-search-strip-airport-field > .MuiTypography-root:first-of-type,\n  .flight-search-strip--ow-rt .flight-search-strip-travelers-field > .MuiTypography-root:first-of-type {\n    min-height: 20px;\n    line-height: 20px !important;\n    margin-bottom: 4px !important;\n  }\n\n  .flight-search-strip--ow-rt .flight-search-strip-date-field > .MuiBox-root:first-child,\n  .flight-search-strip--ow-rt .flight-search-strip-dates-row .flight-search-strip-date-field > .MuiBox-root:first-child,\n  .flight-search-strip--ow-rt .flight-search-strip-class-field > .MuiBox-root:first-child {\n    min-height: 20px;\n    margin-bottom: 4px !important;\n    align-items: center;\n  }\n\n  .flight-search-strip--ow-rt .flight-search-strip-airport-field .MuiAutocomplete-root .MuiOutlinedInput-root,\n  .flight-search-strip--ow-rt .flight-search-strip-date-field .MuiOutlinedInput-root,\n  .flight-search-strip--ow-rt .flight-search-strip-dates-row .MuiOutlinedInput-root,\n  .flight-search-strip--ow-rt .flight-search-strip-travelers-field .MuiOutlinedInput-root,\n  .flight-search-strip--ow-rt .flight-search-strip-class-field .MuiOutlinedInput-root {\n    min-height: 32px !important;\n    height: 32px !important;\n  }\n\n  .flight-search-strip--ow-rt .flight-search-strip-airport-field .MuiInputBase-input,\n  .flight-search-strip--ow-rt .flight-search-strip-date-field .MuiInputBase-input,\n  .flight-search-strip--ow-rt .flight-search-strip-dates-row .flight-search-strip-date-field .MuiInputBase-input,\n  .flight-search-strip--ow-rt .flight-search-strip-travelers-field .MuiInputBase-input,\n  .flight-search-strip--ow-rt .flight-search-strip-class-field .MuiInputBase-input,\n  .flight-search-strip--ow-rt .flight-search-strip-class-field .MuiSelect-select {\n    min-height: 32px !important;\n    height: 32px !important;\n    line-height: 32px !important;\n    padding: 0 !important;\n    box-sizing: border-box;\n  }\n\n  .flight-search-strip--ow-rt > .flight-form-swap-col {\n    align-self: flex-start;\n    margin-top: 24px;\n  }\n\n  /* 48px CTA vertically centered against 12px/16px label + 4px gap + 32px value */\n  .flight-search-strip--ow-rt > .flight-search-strip-cta-field {\n    align-self: flex-start;\n    margin-top: 4px;\n  }\n}\n\n\n/* ===============================================\n   MOBILE + TABLET (below md / <900px)\n   =============================================== */\n@media (max-width: 899.98px) {\n  /* Search strip: FROM/TO side by side, other fields stack full-width */\n  .flight-search-strip {\n    flex-direction: row !important;\n    flex-wrap: wrap !important;\n    gap: 0 !important;\n    padding: 0 !important;\n    border: none !important;\n    border-radius: 0 !important;\n    align-items: center !important;\n    background: transparent !important;\n  }\n\n  /* Prevent iOS input zoom — use max() so JSX font-size can still win when larger */\n  .flight-search-strip input {\n    font-size: max(16px, inherit);\n    -webkit-appearance: none;\n    appearance: none;\n  }\n\n  .special-fares-slider-wrap {\n    padding-left: 0 !important;\n  }\n\n  .special-fares-options {\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior-x: contain;\n    flex-wrap: nowrap !important;\n    padding-bottom: 6px;\n    scroll-snap-type: x proximity;\n  }\n\n  .special-fares-options > div {\n    flex-shrink: 0;\n    scroll-snap-align: start;\n    min-height: var(--yovo-tap-min);\n  }\n\n  /* From | swap | To — single full-width divider; swap centered on vertical rule */\n  .flight-search-strip-from-to-row {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    width: 100%;\n    flex: 1 1 100%;\n    border-bottom: 1px solid #E8E9ED;\n    box-sizing: border-box;\n  }\n\n  .flight-search-strip-from-to-row > .flight-search-strip-airport-field {\n    flex: 1 1 0;\n    min-width: 0;\n    border-bottom: none !important;\n  }\n\n  .flight-search-strip-airport-field .MuiOutlinedInput-root {\n    min-height: unset !important;\n    height: auto !important;\n    padding: 0 !important;\n  }\n\n  .flight-search-strip-airport-field .MuiInputBase-input {\n    line-height: 1.75rem !important;\n    height: auto !important;\n    padding: 0 !important;\n  }\n\n  /* Swap column — fixed width; long airport names never shift the control (<900px) */\n  .flight-form-swap-col {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 40px;\n    width: 40px;\n    min-width: 40px;\n    align-self: stretch;\n    border-bottom: none !important;\n    padding: 0;\n    box-sizing: border-box;\n  }\n\n  .flight-form-swap-divider {\n    display: block;\n  }\n}\n\n/* ===== Figma 2819:182406 — flight form swap (one-way, round-trip, multicity; all breakpoints) ===== */\n.flight-form-swap {\n  flex-shrink: 0;\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  border-radius: 50%;\n  background: var(--neutrals-base-white, #FBFBFB);\n  border: 1px solid var(--neutrals-grey-600, #717180);\n  box-shadow: none;\n  cursor: pointer;\n  box-sizing: border-box;\n  transition: background-color 0.2s ease;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n}\n\n.flight-form-swap:hover {\n  background: var(--Neutrals-grey-200, #F3F3F7);\n}\n\n.flight-form-swap:active {\n  background: var(--Neutrals-grey-300, #E8E9ED);\n}\n\n.flight-form-swap:focus {\n  outline: none;\n}\n\n.flight-form-swap:focus-visible {\n  outline: 2px solid rgba(26, 24, 39, 0.35);\n  outline-offset: 2px;\n}\n\n.flight-form-swap-icon {\n  width: 16px;\n  height: 16px;\n  display: block;\n  flex-shrink: 0;\n}\n\n/* Vertical rule — Figma imgGroup1000001799; grey-400, passes behind the circle */\n.flight-form-swap-divider {\n  position: absolute;\n  left: 50%;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  margin-left: -0.5px;\n  background: var(--neutrals-grey-400, #DAD9E0);\n  z-index: 0;\n  pointer-events: none;\n}\n\n/* Mobile/tablet: clip vertical rule to swap zone — clear gap above horizontal From/To border */\n@media (max-width: 899.98px) {\n  .flight-form-swap-divider {\n    top: 50%;\n    bottom: auto;\n    height: 44px;\n    transform: translate(-50%, -50%);\n    margin-left: 0;\n  }\n}\n\n@media (min-width: 900px) {\n  .flight-form-swap-col {\n    flex: 0 0 auto;\n    width: auto;\n    min-width: auto;\n    align-self: center;\n  }\n\n  /* Desktop multicity / strip: same button; no full-height vertical rule */\n  .flight-form-swap-divider {\n    display: none;\n  }\n}\n\n@media (max-width: 899.98px) {\n  /* Class — match Travel Date / Travelers label-to-value spacing; no trailing divider */\n  .flight-search-strip-class-field {\n    border-bottom: none !important;\n    padding-bottom: 0 !important;\n  }\n\n  /* Travel Date & Travelers — tighter gap below value before divider (~50% less bottom pad) */\n  .flight-search-strip-date-field .MuiTextField-root,\n  .flight-search-strip-travelers-field .MuiTextField-root,\n  .flight-search-strip-date-field .MuiFormControl-root,\n  .flight-search-strip-travelers-field .MuiFormControl-root {\n    margin-bottom: 0 !important;\n  }\n\n  .flight-search-strip-date-field .MuiOutlinedInput-root,\n  .flight-search-strip-travelers-field .MuiOutlinedInput-root {\n    min-height: unset !important;\n    height: auto !important;\n    padding: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .flight-search-strip-date-field .MuiInputBase-input,\n  .flight-search-strip-travelers-field .MuiInputBase-input {\n    padding: 0 !important;\n    line-height: 22px !important;\n    height: auto !important;\n  }\n\n  .flight-search-strip-class-field .MuiTextField-root,\n  .flight-search-strip-class-field .MuiFormControl-root {\n    margin-bottom: 0 !important;\n  }\n\n  .flight-search-strip-class-field .MuiOutlinedInput-root {\n    min-height: unset !important;\n    height: auto !important;\n    padding: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .flight-search-strip-class-field .MuiInputBase-input {\n    padding: 0 !important;\n    line-height: 22px !important;\n    height: auto !important;\n  }\n}\n\n/* ===== iOS safe area (landscape on touch devices only) ===== */\n@supports (padding-left: env(safe-area-inset-left)) {\n  @media (orientation: landscape) and (hover: none) and (pointer: coarse) {\n    .special-fares-slider-wrap {\n      padding-left: env(safe-area-inset-left);\n      padding-right: env(safe-area-inset-right);\n    }\n  }\n}\n\n/* ===== iOS Safari flexbox fixes ===== */\n@supports (-webkit-touch-callout: none) {\n  .special-fares-options {\n    overscroll-behavior: contain;\n  }\n\n  .flight-search-strip {\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n\n/* ===============================================\n   Airport Dropdown — Search Bar + Options\n   =============================================== */\n\n.flight-dropdown-search-bar {\n  display: flex;\n  align-items: center;\n  background: #F4F5F7;\n  border: 1px solid #E6E7ED;\n  border-radius: 10px;\n  padding: 8px 10px;\n  gap: 10px;\n}\n\n.flight-dropdown-search-icon {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n.flight-dropdown-search-input {\n  border: none;\n  background: transparent;\n  outline: none;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22px;\n  color: #20202A;\n  width: 100%;\n  min-width: 0;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.flight-dropdown-search-clear {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: #7E808F;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.flight-dropdown-search-clear:hover {\n  background: #E4E5EA;\n  color: #20202A;\n}\n\n.flight-dropdown-search-input::placeholder {\n  color: #AEAEB8;\n  opacity: 1;\n}\n\n.flight-dropdown-empty {\n  padding: 16px 12px 8px;\n  text-align: center;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  color: #8B8D98;\n  list-style: none;\n}\n\n.flight-dropdown-separator {\n  padding: 3px 10px !important;\n  background: #EEF0FB !important;\n  color: #4E5694 !important;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  line-height: 18px !important;\n  border-radius: 6px;\n  margin: 6px 4px !important;\n  cursor: default !important;\n  pointer-events: none;\n  display: inline-flex !important;\n  align-items: center;\n  width: fit-content !important;\n  min-height: auto !important;\n  box-sizing: border-box;\n}\n\n.flight-dropdown-option {\n  padding: 10px 8px;\n  font-size: 14px;\n  line-height: 1.35;\n  display: flex !important;\n  align-items: center !important;\n  cursor: pointer;\n  background-color: transparent;\n  transition: background-color 0.15s ease;\n  min-height: auto;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.flight-dropdown-option:hover {\n  background-color: #EDEDF0;\n}\n\n.flight-dropdown-option[data-nearest=\"true\"] {\n  padding: 10px 8px 10px 36px !important;\n}\n\n.flight-dropdown-option-icon {\n  width: 18px;\n  height: 18px;\n  margin-right: 8px;\n  flex-shrink: 0;\n  margin-top: 0 !important;\n  align-self: center;\n  display: block;\n  filter: brightness(0);\n}\n\n.flight-dropdown-option-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.flight-dropdown-option-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 8px;\n}\n\n.flight-dropdown-option-city {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-weight: 600;\n  color: #20202A;\n  font-size: 15px;\n  line-height: 20px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.flight-dropdown-option-airport {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: 0.1px;\n  color: #8E909C;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.flight-dropdown-option-code {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-weight: 600;\n  color: #545665;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.3px;\n  flex-shrink: 0;\n  margin-left: 8px;\n  align-self: center;\n  background: #F1F2F6;\n  border-radius: 8px;\n  padding: 2px 8px;\n  min-width: 42px;\n  text-align: center;\n}\n\n/* Mobile: full-width dropdown */\n@media (max-width: 899.98px) {\n  .flight-dropdown-search-bar {\n    padding: 10px 10px;\n    gap: 12px;\n  }\n}\n\n\n/* ===============================================\n   Mobile airport bottom sheet (From / To — Portal)\n   Fixed bottom, dvh + safe-area for iOS; list scrolls inside sheet.\n   =============================================== */\n.mobile-airport-sheet-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1300;\n  background: rgba(32, 32, 42, 0.45);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.22s ease, visibility 0.22s ease;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.mobile-airport-sheet-backdrop.open {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n\n/* Airport sheet: shared shell (FlightForm mobile Portal). Breakpoints align with MUI md (900px). */\n.mobile-airport-sheet {\n  position: fixed;\n  z-index: 1301;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  background: #fff;\n  transform: translate3d(0, 100%, 0);\n  transition: transform 0.28s cubic-bezier(0.32, 0.72, 0, 1);\n  overflow: hidden;\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* xs + sm: half bottom sheet — Figma 6544:98008 (not full-screen) */\n@media (max-width: 899.98px) {\n  .mobile-airport-sheet {\n    inset: auto 0 0 0;\n    top: auto;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: auto;\n    min-height: min(42dvh, 100dvh);\n    max-height: min(58dvh, calc(100dvh - env(safe-area-inset-top, 0px) - 3.5rem));\n    border-radius: 16px 16px 0 0;\n    box-shadow: 0 0 12px rgba(0, 0, 0, 0.12);\n    background: #fafafd;\n    padding-top: 0;\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n  }\n\n  /* Typing: fill the visual viewport so the airport list sits above the keyboard. */\n  .mobile-airport-sheet.open.is-keyboard-open {\n    bottom: var(--mobile-keyboard-inset, 0px);\n    height: var(--mobile-vv-height, 100dvh);\n    min-height: 0;\n    max-height: var(--mobile-vv-height, 100dvh);\n    padding-bottom: 0;\n  }\n}\n\n.mobile-airport-sheet.open {\n  transform: translate3d(0, 0, 0);\n}\n\n/* Closed sheet must not paint or intercept touches (Android scroll peek guard). */\n.mobile-airport-sheet:not(.open) {\n  visibility: hidden;\n  pointer-events: none;\n}\n\n/* Keep handle / header / inputs from shrinking; only the results list flexes and scrolls */\n.mobile-airport-sheet > *:not(.mobile-sheet-results) {\n  flex-shrink: 0;\n}\n\n/* Mobile date picker bottom sheet — matches airport sheet UX; stacks above airport layer */\n.mobile-date-sheet-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1310;\n  background: rgba(32, 32, 42, 0.45);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.22s ease, visibility 0.22s ease;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.mobile-date-sheet-backdrop.open {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n\n.mobile-airport-sheet.mobile-date-picker-sheet {\n  z-index: 1311;\n}\n\n@media (max-width: 899.98px) {\n  .mobile-airport-sheet.mobile-date-picker-sheet {\n    height: auto;\n    min-height: min(60dvh, 100dvh);\n    max-height: 100dvh;\n  }\n}\n\n.mobile-date-picker-scroll-area {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior-y: contain;\n  touch-action: pan-y;\n  padding: 0 0.75rem 1rem;\n  padding-bottom: max(1rem, env(safe-area-inset-bottom, 0px));\n}\n\n/* Mobile date picker: bottom sheet + rounded top corners (Search Date) */\n.mobile-date-fullscreen-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1399;\n  background: rgba(32, 32, 42, 0.45);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.mobile-date-fullscreen-sheet {\n  position: fixed;\n  z-index: 1400;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  background: #fbfbfb;\n  overflow: hidden;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* xs + sm: full-screen journey duration / Search Date — matches Travellers & Class */\n@media (max-width: 899.98px) {\n  .mobile-date-fullscreen-sheet {\n    inset: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    height: 100vh;\n    height: 100dvh;\n    min-height: 100vh;\n    min-height: 100dvh;\n    max-height: 100vh;\n    max-height: 100dvh;\n    border-radius: 0;\n    box-shadow: none;\n    padding-top: env(safe-area-inset-top, 0px);\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n  }\n}\n\n.mobile-date-fullscreen-header {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px 10px;\n  box-sizing: border-box;\n}\n\n.mobile-date-fullscreen-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior-y: contain;\n  touch-action: pan-y;\n  padding: 8px 12px 12px;\n}\n\n.mobile-date-fullscreen-datepicker-wrap {\n  width: 100%;\n  max-width: 100%;\n}\n\n.mobile-fullscreen-datepicker.react-datepicker {\n  display: flex !important;\n  flex-direction: column !important;\n  width: 100% !important;\n  max-width: 100% !important;\n  border: none !important;\n  box-shadow: none !important;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  background: transparent !important;\n}\n\n.mobile-fullscreen-datepicker .react-datepicker__month-container {\n  width: 100% !important;\n  float: none !important;\n  margin-bottom: 1rem;\n}\n\n.mobile-date-fullscreen-footer {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 9px 16px 12px;\n  padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));\n  background: #fbfbfb;\n  border-top: 1px solid #e8e9ed;\n  box-sizing: border-box;\n  overflow: visible;\n}\n\n.mobile-date-fullscreen-summary-row {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  position: relative;\n  width: 100%;\n  overflow: visible;\n  box-sizing: border-box;\n}\n\n.mobile-date-summary-box-wrap {\n  position: relative;\n  flex: 1 1 0;\n  min-width: 0;\n  overflow: visible;\n  box-sizing: border-box;\n}\n\n.mobile-date-summary-box-wrap--full {\n  flex: 1 1 100%;\n}\n\n/* Figma 6544:99362 — top-right corner of chip, half overlaps border */\n.mobile-date-summary-clear {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: auto;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  margin: 0;\n  border: none;\n  border-radius: 30px;\n  background: #717180;\n  cursor: pointer;\n  transform: translate(50%, -50%);\n  -webkit-tap-highlight-color: transparent;\n  box-sizing: border-box;\n  line-height: 0;\n}\n\n.mobile-date-fullscreen-summary-box {\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n  height: 56px;\n  min-height: 56px;\n  max-height: 56px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  padding: 8px 16px;\n  box-sizing: border-box;\n  background: #f3f3f7;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  text-align: left;\n  overflow: hidden;\n}\n\n.mobile-date-fullscreen-summary-box--interactive {\n  margin: 0;\n  appearance: none;\n  -webkit-appearance: none;\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  outline: none;\n  box-shadow: none;\n}\n\n.mobile-date-fullscreen-summary-box--interactive:focus,\n.mobile-date-fullscreen-summary-box--interactive:focus-visible,\n.mobile-date-fullscreen-summary-box--interactive:active {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.mobile-date-fullscreen-summary-box.mobile-date-fullscreen-summary-box--return-empty {\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.mobile-date-summary-return-placeholder {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #9e9e9e;\n  width: 100%;\n  text-align: center;\n}\n\nbutton.mobile-date-fullscreen-summary-box {\n  margin: 0;\n  appearance: none;\n  -webkit-appearance: none;\n  font: inherit;\n  color: inherit;\n  width: 100%;\n  border: 1px solid transparent !important;\n  background: #f3f3f7 !important;\n  outline: none;\n  box-shadow: none;\n}\n\nbutton.mobile-date-fullscreen-summary-box:focus,\nbutton.mobile-date-fullscreen-summary-box:focus-visible,\nbutton.mobile-date-fullscreen-summary-box:active {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.mobile-date-fullscreen-summary-box.active {\n  /* filled — stroke only on focused segment (see below) */\n}\n\n/* Figma 6544:99353/99354 — 1px #252637 stroke on active footer chip */\n[data-mobile-date-sheet] .mobile-date-fullscreen-footer .mobile-date-fullscreen-summary-box[data-segment-focused='true'],\n[data-mobile-date-sheet] .mobile-date-fullscreen-footer .mobile-date-fullscreen-summary-box.hotel-date-segment-focused,\n[data-mobile-date-sheet] .mobile-date-fullscreen-footer .mobile-date-fullscreen-summary-box.flight-date-segment-focused,\n[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box[data-segment-focused='true'],\n[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.hotel-date-segment-focused,\n[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.flight-date-segment-focused,\n[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.flight-date-segment-focused:focus,\n[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.flight-date-segment-focused:active,\n[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.hotel-date-segment-focused:focus,\n[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.hotel-date-segment-focused:active {\n  border: 1px solid #252637 !important;\n  background: #f3f3f7 !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n[data-mobile-date-sheet] .mobile-date-fullscreen-footer .mobile-date-fullscreen-summary-box:not([data-segment-focused='true']):not(.hotel-date-segment-focused):not(.flight-date-segment-focused),\n[data-mobile-date-sheet] .mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box:not([data-segment-focused='true']):not(.hotel-date-segment-focused):not(.flight-date-segment-focused) {\n  border: 1px solid transparent !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n/* Legacy selectors — keep for sheets without data-mobile-date-sheet wrapper */\n.mobile-date-fullscreen-footer .mobile-date-fullscreen-summary-box.hotel-date-segment-focused,\n.mobile-date-fullscreen-footer .mobile-date-fullscreen-summary-box.flight-date-segment-focused,\n.mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.hotel-date-segment-focused,\n.mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box.flight-date-segment-focused {\n  border: 1px solid #252637 !important;\n  background: #f3f3f7 !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.mobile-date-fullscreen-footer .mobile-date-fullscreen-summary-box:not(.hotel-date-segment-focused):not(.flight-date-segment-focused),\n.mobile-date-fullscreen-footer button.mobile-date-fullscreen-summary-box:not(.hotel-date-segment-focused):not(.flight-date-segment-focused) {\n  border: 1px solid transparent !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n/* Save — Figma 6544:99370 */\n.mobile-date-fullscreen-save.MuiButton-root {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;\n  text-transform: none !important;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  line-height: 22px !important;\n  min-height: 48px !important;\n  padding: 8px 32px !important;\n  border-radius: 4px !important;\n  background-color: #1a1827 !important;\n  color: #fbfbfb !important;\n  box-shadow: none !important;\n}\n\n.mobile-date-fullscreen-save.MuiButton-root:hover {\n  background-color: #252637 !important;\n  box-shadow: none !important;\n}\n\n.mobile-date-fullscreen-save.MuiButton-root.Mui-disabled {\n  background-color: #c3c3cd !important;\n  color: #f5f5f7 !important;\n}\n\n/* Round-trip: Departure + Return side by side inside one strip cell */\n.flight-search-strip-dates-row {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  box-sizing: border-box;\n  position: relative;\n  min-width: 0;\n}\n\n.flight-search-strip-dates-row > .flight-search-strip-date-field {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n/* Narrower desktops: wrap whole fields. Dates and counts keep their text width. */\n@media (min-width: 900px) and (max-width: 1199.98px) {\n  .flight-search-strip:not(.flight-select-hero-strip) {\n    flex-wrap: wrap;\n    column-gap: 16px;\n    row-gap: 0;\n    justify-content: flex-start;\n  }\n\n  .flight-search-strip--ow-rt:not(.flight-select-hero-strip) > .flight-search-strip-from-to-row {\n    display: flex;\n    flex: 0 0 auto;\n    align-items: flex-start;\n    gap: 12px;\n    width: auto;\n  }\n\n  .flight-search-strip--ow-rt:not(.flight-select-hero-strip) > .flight-search-strip-from-to-row > .flight-form-swap-col {\n    align-self: flex-start;\n    margin-top: 24px;\n  }\n\n  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-date-field,\n  .flight-search-strip:not(.flight-select-hero-strip) .flight-search-strip-dates-row > .flight-search-strip-date-field {\n    flex: 0 0 auto;\n    min-width: 112px;\n  }\n\n  .flight-search-strip:not(.flight-select-hero-strip) .flight-search-strip-dates-row {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n    min-width: 0;\n    column-gap: 12px;\n  }\n\n  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-travelers-field {\n    flex: 0 0 auto;\n    width: 152px;\n    min-width: 152px;\n    max-width: 152px;\n  }\n\n  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-travelers-field .MuiInputBase-root,\n  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-travelers-field .MuiInputBase-input {\n    width: 100% !important;\n    min-width: 0 !important;\n    max-width: 152px;\n  }\n\n  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-class-field {\n    flex: 0 0 auto;\n    width: auto;\n    min-width: 5.5rem;\n  }\n}\n\n/* Wide desktop: fields share the row and Let's Go stays at the end. Dates still cannot shrink away. */\n@media (min-width: 1200px) {\n  .flight-search-strip:not(.flight-select-hero-strip) {\n    flex-wrap: nowrap !important;\n    column-gap: 24px;\n    row-gap: 0;\n  }\n\n  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-airport-field {\n    flex: 1.1 1 0;\n    width: auto;\n    max-width: none;\n  }\n\n  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-date-field {\n    flex: 1 1 0;\n    min-width: 112px;\n  }\n\n  .flight-search-strip:not(.flight-select-hero-strip) .flight-search-strip-dates-row {\n    flex: 1.3 1 0;\n    width: auto;\n    max-width: none;\n    min-width: 224px;\n    column-gap: 16px;\n  }\n\n  .flight-search-strip:not(.flight-select-hero-strip) .flight-search-strip-dates-row > .flight-search-strip-date-field {\n    flex: 1 1 0;\n    min-width: 112px;\n  }\n\n  .flight-search-strip:not(.flight-select-hero-strip) .flight-search-strip-dates-row > .flight-search-strip-date-field:last-of-type {\n    padding-left: 0;\n  }\n\n  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-travelers-field {\n    flex: 1 1 0;\n    min-width: 152px;\n  }\n\n  .flight-search-strip:not(.flight-select-hero-strip) > .flight-search-strip-class-field {\n    flex: 0 0 7.75rem;\n    width: 7.75rem;\n  }\n}\n\n@media (min-width: 900px) {\n  /*\n   * FlightSelect hero — flat grid:\n   * RT: Journey | [From⇄To] | Dep | Ret | Travellers | Class | CTA(auto)\n   * OW: Journey | [From⇄To] | Dep | Travellers | Class | CTA(auto)\n   */\n  .flight-select-hero-strip {\n    display: grid !important;\n    align-items: start;\n    column-gap: clamp(8px, 1vw, 14px);\n    width: 100%;\n    flex-wrap: unset !important;\n    justify-content: unset;\n  }\n\n  .flight-select-hero-strip--roundtrip {\n    grid-template-columns:\n      auto\n      minmax(0, 2.4fr)\n      repeat(4, minmax(0, 1fr))\n      auto;\n  }\n\n  .flight-select-hero-strip--oneway {\n    grid-template-columns:\n      auto\n      minmax(0, 2.4fr)\n      repeat(3, minmax(0, 1fr))\n      auto;\n  }\n\n  /* MC: Journey | From | To | Dates | Travellers | Class | CTA(auto) */\n  .flight-select-hero-strip--multicity {\n    grid-template-columns:\n      auto\n      repeat(2, minmax(0, 1.2fr))\n      repeat(3, minmax(0, 1fr))\n      auto;\n  }\n\n  .flight-select-hero-strip > .flight-select-hero-meta-group,\n  .flight-select-hero-strip .flight-search-strip-dates-row {\n    display: contents;\n  }\n\n  /* Single grid cell: From + swap overlay + To */\n  .flight-select-hero-strip > .flight-select-hero-from-to-group {\n    display: flex !important;\n    flex-direction: row;\n    align-items: stretch;\n    position: relative;\n    min-width: 0;\n    gap: 0;\n  }\n\n  .flight-select-hero-from-to-group > .flight-select-hero-airport-field {\n    flex: 1 1 0;\n    min-width: 0;\n    overflow: hidden;\n  }\n\n  /*\n   * Figma-style From | swap | To (reference):\n   *   label + city left-stacked per side, fixed swap column, equal flex halves\n   */\n  .flight-select-hero-from-to-group > .flight-select-hero-airport-field--from,\n  .flight-select-hero-from-to-group > .flight-select-hero-airport-field--to {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .flight-select-hero-from-to-group > .flight-select-hero-airport-field--from {\n    padding-right: 0.75rem;\n  }\n\n  .flight-select-hero-from-to-group > .flight-select-hero-airport-field--to {\n    padding-left: 0.75rem;\n  }\n\n  .flight-select-hero-from-to-group .flight-select-hero-airport-label,\n  .flight-select-hero-from-to-group .flight-select-hero-airport-value,\n  .flight-select-hero-from-to-group .MuiAutocomplete-input,\n  .flight-select-hero-from-to-group .MuiInputBase-input,\n  .flight-select-hero-from-to-group .MuiOutlinedInput-input {\n    text-align: left;\n  }\n\n  .flight-select-hero-from-to-group .flight-select-hero-airport-label {\n    justify-content: flex-start;\n  }\n\n  .flight-select-hero-from-to-group > .flight-form-swap-col.flight-select-hero-swap-field {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 40px;\n    width: 40px;\n    min-width: 40px;\n    align-self: flex-start;\n    margin-top: calc(18px + 4px + (28px - 32px) / 2);\n    z-index: 3;\n    overflow: visible;\n    pointer-events: none;\n    border-bottom: none !important;\n    padding: 0;\n    box-sizing: border-box;\n  }\n\n  .flight-select-hero-from-to-group > .flight-form-swap-col.flight-select-hero-swap-field .flight-form-swap {\n    position: relative;\n    z-index: 1;\n    pointer-events: auto;\n  }\n\n  /* Vertical rule bisects swap circle — same as Figma / mobile FlightForm */\n  .flight-select-hero-from-to-group > .flight-form-swap-col.flight-select-hero-swap-field .flight-form-swap-divider {\n    display: block !important;\n    left: 50%;\n    top: 50%;\n    bottom: auto;\n    width: 1px;\n    height: 2.75rem;\n    margin: 0;\n    transform: translate(-50%, -50%);\n    z-index: 0;\n  }\n\n  .flight-select-hero-strip .flight-select-hero-journey-field {\n    min-width: 0;\n    flex: unset !important;\n    padding-left: 0 !important;\n    padding-right: clamp(0.25rem, 0.5vw, 0.5rem) !important;\n  }\n\n  .flight-select-hero-strip .flight-search-strip-date-field,\n  .flight-select-hero-strip .flight-select-hero-duration-field,\n  .flight-select-hero-strip .flight-search-strip-travelers-field,\n  .flight-select-hero-strip .flight-select-hero-class-field {\n    min-width: 0;\n    overflow: hidden;\n    flex: unset !important;\n    padding-left: 0;\n    padding-right: 0;\n    align-items: flex-start;\n    text-align: left;\n  }\n\n  .flight-select-hero-strip .flight-select-hero-label-row,\n  .flight-select-hero-strip .flight-select-hero-airport-label,\n  .flight-select-hero-strip .flight-search-strip-date-field .flight-select-hero-date-label,\n  .flight-select-hero-strip .flight-select-hero-duration-field .flight-select-hero-date-label {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    height: 18px;\n    min-height: 18px;\n    padding: 0;\n    margin: 0;\n  }\n\n  .flight-select-hero-strip .flight-select-hero-option-dropdown button {\n    font-size: 1rem;\n    font-weight: 700;\n    line-height: 28px;\n    height: 28px;\n  }\n\n  .flight-select-hero-strip .flight-select-hero-airport-value-row,\n  .flight-select-hero-strip .flight-select-hero-airport-value-row > div,\n  .flight-select-hero-strip .flight-select-hero-date-value,\n  .flight-select-hero-strip .flight-select-hero-option-dropdown,\n  .flight-select-hero-strip .flight-search-strip-travelers-field .MuiOutlinedInput-root {\n    height: 28px !important;\n    min-height: 28px !important;\n    max-height: 28px !important;\n  }\n\n  .flight-select-hero-strip .flight-select-hero-airport-value,\n  .flight-select-hero-strip .flight-select-hero-date-value,\n  .flight-select-hero-strip .flight-search-strip-travelers-field .MuiInputBase-input {\n    line-height: 28px !important;\n    height: 28px !important;\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    display: flex;\n    align-items: center;\n  }\n\n  .flight-select-hero-strip .flight-select-hero-date-value {\n    padding: 0 !important;\n    margin: 0 !important;\n    text-align: left !important;\n    align-self: flex-start;\n    width: 100%;\n  }\n\n  .flight-select-hero-strip .flight-select-hero-airport-value,\n  .flight-select-hero-strip .MuiAutocomplete-input,\n  .flight-select-hero-strip .MuiInputBase-input {\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .flight-select-hero-strip .flight-select-hero-search-btn {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-left: 0 !important;\n    overflow: visible;\n    flex: unset !important;\n    width: auto;\n    min-width: 0;\n  }\n}\n\n@media (max-width: 899.98px) {\n  .flight-search-strip-dates-row {\n    width: 100%;\n    flex: 1 1 100%;\n    border-bottom: 1px solid #E8E9ED;\n  }\n\n  .flight-search-strip-dates-row > .flight-search-strip-date-field {\n    border-bottom: none !important;\n  }\n}\n\n.mobile-date-fullscreen-summary-box.single {\n  flex: 1 1 100%;\n}\n\n/* ── MobileSearchDateSheet: fixed weekday header row (outside scroll) ── */\n.mobile-date-sheet-weekday-row {\n  display: flex;\n  flex-shrink: 0;\n  justify-content: space-around;\n  align-items: center;\n  padding: 4px 12px 8px;\n  background: #fbfbfb;\n  box-sizing: border-box;\n}\n\n.mobile-date-sheet-weekday-cell {\n  flex: 1 1 0;\n  text-align: center;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: #434151;\n  letter-spacing: 0;\n  line-height: 16px;\n}\n\n/* Hide per-month day-name rows inside the fullscreen datepicker (we show our own fixed row) */\n.mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day-names {\n  display: none !important;\n}\n\n/* Hide navigation arrows (< >) — months scroll vertically, no paging */\n.mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__navigation {\n  display: none !important;\n}\n\n/* Month heading: clean centered text, no background */\n.mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__header {\n  background: transparent !important;\n  border-bottom: none !important;\n  padding-top: 8px;\n  padding-bottom: 4px;\n}\n\n.mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__current-month,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__current-month {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;\n  font-size: 20px !important;\n  font-weight: 700 !important;\n  color: #252637 !important;\n  text-align: center !important;\n  padding: 12px 0 8px !important;\n  line-height: 28px !important;\n  letter-spacing: 0 !important;\n  margin: 0 !important;\n}\n\n/* Mobile date sheet (FlightForm isMobile — below MUI md / 900px): selected / range ends — #CF2048, beats GlobalStyles + inline fare colors */\n@media (max-width: 899.98px) {\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--selected,\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--selected:hover {\n    background-color: #cf2048 !important;\n    background: #cf2048 !important;\n    color: #fff !important;\n    border-radius: 3px !important;\n    font-weight: 700 !important;\n  }\n\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--keyboard-selected.react-datepicker__day--selected,\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--keyboard-selected.react-datepicker__day--selected:hover {\n    background-color: #cf2048 !important;\n    background: #cf2048 !important;\n    color: #fff !important;\n  }\n\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start,\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-end,\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start:hover,\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-end:hover {\n    background-color: #cf2048 !important;\n    background: #cf2048 !important;\n    color: #fff !important;\n    border-radius: 3px !important;\n    font-weight: 700 !important;\n  }\n\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range,\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--in-range,\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-end.react-datepicker__day--in-range {\n    background-color: #cf2048 !important;\n    background: #cf2048 !important;\n    color: #fff !important;\n  }\n\n  /* Figma range band — #FFDEE5 at ~56% opacity between departure and return endpoints */\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end),\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {\n    background-color: rgba(255, 222, 229, 0.56) !important;\n    color: #434151 !important;\n    border-radius: 0 !important;\n  }\n\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start:not(.react-datepicker__day--range-end) {\n    border-radius: 3px 0 0 3px !important;\n  }\n\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-end:not(.react-datepicker__day--range-start) {\n    border-radius: 0 3px 3px 0 !important;\n  }\n\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--range-end {\n    border-radius: 3px !important;\n  }\n\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--selected[style],\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start[style],\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-end[style] {\n    background-color: #cf2048 !important;\n    background: #cf2048 !important;\n    color: #fff !important;\n  }\n\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--selected > div > span:first-child,\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start > div > span:first-child,\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-end > div > span:first-child {\n    color: #fff !important;\n  }\n\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--selected > div > span:last-child,\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-start > div > span:last-child,\n  .mobile-date-fullscreen-scroll .mobile-fullscreen-datepicker .react-datepicker__day--range-end > div > span:last-child {\n    color: rgba(255, 255, 255, 0.92) !important;\n  }\n}\n\n/* ── Mobile Search Date sheet (Figma 6544:98832) — grid + range colors beat Homepage GlobalStyles ── */\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker.custom-datepicker-single-month .react-datepicker__month {\n  margin: 0 !important;\n  padding: 0 !important;\n  width: 100% !important;\n}\n\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker.custom-datepicker-single-month .react-datepicker__week {\n  display: grid !important;\n  grid-template-columns: repeat(7, minmax(0, 1fr)) !important;\n  width: 100% !important;\n  margin: 0 0 6px !important;\n  column-gap: 0 !important;\n}\n\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker.custom-datepicker-single-month .react-datepicker__day {\n  width: 100% !important;\n  max-width: none !important;\n  min-width: 0 !important;\n  height: auto !important;\n  min-height: 48px !important;\n  margin: 2px 0 !important;\n  padding: 6px 2px !important;\n  box-sizing: border-box !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  line-height: 20px !important;\n  color: #434151 !important;\n  border-radius: 0 !important;\n}\n\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker.custom-datepicker-single-month .react-datepicker__day--disabled {\n  color: #ccc !important;\n  cursor: not-allowed !important;\n  background: transparent !important;\n  background-color: transparent !important;\n}\n\n/* Round-trip endpoints — #CF2048 (beats GlobalStyles #ab2645 + inline styles) */\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-end,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start:hover,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-end:hover,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--in-range,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-end.react-datepicker__day--in-range,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--selected,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--selected.react-datepicker__day--range-start,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start[style],\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-end[style],\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--selected[style] {\n  background-color: #cf2048 !important;\n  background: #cf2048 !important;\n  color: #fff !important;\n  font-weight: 700 !important;\n}\n\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start:not(.react-datepicker__day--range-end) {\n  border-radius: 3px 0 0 3px !important;\n}\n\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-end:not(.react-datepicker__day--range-start) {\n  border-radius: 0 3px 3px 0 !important;\n}\n\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--range-end {\n  border-radius: 3px !important;\n}\n\n/* Pink range band — #FFDEE5 ~56% */\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end),\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end):hover,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end),\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end):hover {\n  background-color: rgba(255, 222, 229, 0.56) !important;\n  background: rgba(255, 222, 229, 0.56) !important;\n  color: #434151 !important;\n  border-radius: 0 !important;\n}\n\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end)[style],\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end)[style] {\n  background-color: rgba(255, 222, 229, 0.56) !important;\n  background: rgba(255, 222, 229, 0.56) !important;\n}\n\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start > div > span:first-child,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-end > div > span:first-child,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--selected > div > span:first-child {\n  color: #fff !important;\n}\n\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-start > div > span:last-child,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--range-end > div > span:last-child,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--selected > div > span:last-child {\n  color: rgba(255, 255, 255, 0.92) !important;\n}\n\n/* Desktop flight calendar — same theme red as the mobile date sheet */\n@media (min-width: 900px) {\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--selected,\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--selected:hover,\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-start,\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-end,\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-start:hover,\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-end:hover,\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-start.react-datepicker__day--selected,\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-start.react-datepicker__day--in-range,\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-end.react-datepicker__day--in-range,\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--selected[style],\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-start[style],\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--range-end[style] {\n    background-color: #CF2048 !important;\n    background: #CF2048 !important;\n    color: #fff !important;\n  }\n\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end),\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {\n    background-color: rgba(255, 222, 229, 0.56) !important;\n    background: rgba(255, 222, 229, 0.56) !important;\n    color: #434151 !important;\n  }\n}\n\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) > div > span:first-child,\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) > div > span:first-child {\n  color: #434151 !important;\n}\n\n[data-mobile-date-sheet] .mobile-fullscreen-datepicker .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--selected):not(.react-datepicker__day--in-range):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {\n  background: transparent !important;\n  color: #434151 !important;\n}\n\n.fare-date-calendar {\n  width: 100%;\n}\n\n.fare-date-month-title {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  color: #252637;\n  text-align: center;\n  padding: 12px 0 8px;\n  margin: 0;\n  line-height: 28px;\n}\n\n.fare-date-grid {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n  width: 100%;\n  margin: 0 0 6px;\n}\n\n.fare-date-pad,\n.fare-date-cell {\n  min-height: 48px;\n  margin: 2px 0;\n  box-sizing: border-box;\n}\n\n.fare-date-cell {\n  appearance: none;\n  border: 0;\n  background: transparent;\n  width: 100%;\n  padding: 6px 2px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  color: #434151;\n  border-radius: 0;\n  cursor: pointer;\n}\n\n.fare-date-cell:disabled {\n  color: #c5c5c5;\n  cursor: default;\n}\n\n.fare-date-cell-price {\n  font-size: 9px;\n  font-weight: 600;\n  margin-top: 1px;\n  line-height: 1.1;\n  white-space: nowrap;\n}\n\n.fare-date-cell--selected,\n.fare-date-cell--range-single,\n.fare-date-cell--range-start,\n.fare-date-cell--range-end {\n  background: #cf2048;\n  color: #fff;\n  font-weight: 700;\n}\n\n.fare-date-cell--selected,\n.fare-date-cell--range-single {\n  border-radius: 3px;\n}\n\n.fare-date-cell--range-start {\n  border-radius: 3px 0 0 3px;\n}\n\n.fare-date-cell--range-end {\n  border-radius: 0 3px 3px 0;\n}\n\n.fare-date-cell--in-range {\n  background: rgba(255, 222, 229, 0.56);\n  color: #434151;\n}\n\n.fare-date-cell--selected .fare-date-cell-price,\n.fare-date-cell--range-single .fare-date-cell-price,\n.fare-date-cell--range-start .fare-date-cell-price,\n.fare-date-cell--range-end .fare-date-cell-price {\n  color: rgba(255, 255, 255, 0.92) !important;\n}\n\n.mobile-sheet-field {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  width: 100%;\n  height: 56px;\n  min-height: 56px;\n  max-height: 56px;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  background: #f3f3f7;\n  box-sizing: border-box;\n  cursor: text;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.mobile-sheet-field-inner {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n/* Scoped under sheet — Figma 6544:98010 / 6544:98016 */\n.mobile-airport-sheet .mobile-sheet-field:not(.active) {\n  border: 1px solid transparent !important;\n  background: #f3f3f7 !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.mobile-airport-sheet .mobile-sheet-field.active,\n.mobile-airport-sheet .mobile-sheet-field.active:focus-within {\n  border: 1px solid #252637 !important;\n  background: #f3f3f7 !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.mobile-sheet-field-label,\n.mobile-sheet-field-label.MuiTypography-root {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  letter-spacing: 0.25px;\n  color: #535462;\n  margin: 0;\n  padding: 0;\n  display: block;\n}\n\n.mobile-sheet-field-selected {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n  margin-top: 0;\n}\n\n.mobile-sheet-field-code-city {\n  flex-shrink: 0;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  color: #1a1827;\n}\n\n.mobile-sheet-field-airport-name {\n  flex: 1 1 0;\n  min-width: 0;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0.15px;\n  color: #535462;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mobile-sheet-input {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  color: #1a1827;\n  padding: 0;\n  margin: 0;\n  -webkit-appearance: none;\n  appearance: none;\n  -webkit-text-fill-color: #1a1827;\n  box-shadow: none;\n}\n\n/* Active typing — Figma 6544:98019: semibold 16 / 22 */\n.mobile-airport-sheet .mobile-sheet-field.active .mobile-sheet-input,\n.mobile-airport-sheet .mobile-sheet-field.active .mobile-sheet-input:focus {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: #1a1827;\n  -webkit-text-fill-color: #1a1827;\n  outline: none;\n  box-shadow: none;\n  border: none;\n}\n\n.mobile-sheet-input::placeholder {\n  color: #717180;\n  opacity: 1;\n  font-weight: 400;\n  -webkit-text-fill-color: #717180;\n}\n\n.mobile-airport-sheet .mobile-sheet-field.active .mobile-sheet-input::placeholder {\n  color: #717180;\n  font-weight: 400;\n  -webkit-text-fill-color: #717180;\n}\n\n.mobile-sheet-field-clear {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  padding: 4px;\n  margin: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--yovo-grey-700, #686A7A);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.mobile-sheet-field-clear:active {\n  opacity: 0.7;\n}\n\n.mobile-sheet-results {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior-y: contain;\n  touch-action: pan-y;\n  padding: 0 16px max(0.5rem, env(safe-area-inset-bottom, 0px));\n}\n\n@media (max-width: 899.98px) {\n  .mobile-airport-sheet.open.is-keyboard-open .mobile-sheet-results {\n    gap: 1rem;\n    padding-bottom: 12px;\n  }\n}\n\n.mobile-sheet-separator {\n  display: inline-flex !important;\n  align-items: center;\n  align-self: flex-start;\n  width: fit-content !important;\n  padding: 3px 10px !important;\n  margin: 0 !important;\n  background: #eef0fb !important;\n  color: #4e5694 !important;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  line-height: 18px !important;\n  border-radius: 6px;\n  pointer-events: none;\n  box-sizing: border-box;\n}\n\n.mobile-sheet-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.625rem;\n  padding: 0;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.mobile-sheet-option:active {\n  background: #f5f5f7;\n}\n\n/* ===============================================\n   Mobile Travellers & Class — full-screen modal (viewport < 768px; opened from JS)\n   Uses 100dvh (not 100vh) for iOS browser chrome; safe-area insets on header/footer\n   =============================================== */\n.mobile-travellers-sheet-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1350;\n  background: rgba(32, 32, 42, 0.45);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.22s ease, visibility 0.22s ease;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.mobile-travellers-sheet-backdrop.open {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n\n.mobile-travellers-sheet {\n  position: fixed;\n  inset: 0;\n  z-index: 1351;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  /* Full viewport height — dvh avoids iOS 100vh bugs; fallback for older browsers */\n  min-height: 100vh;\n  min-height: 100dvh;\n  height: 100vh;\n  height: 100dvh;\n  max-height: 100vh;\n  max-height: 100dvh;\n  background: #fff;\n  border-radius: 0;\n  box-shadow: none;\n  transform: translate3d(0, 100%, 0);\n  transition: transform 0.3s cubic-bezier(0.32, 0.72, 0, 1);\n  overflow: hidden;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.mobile-travellers-sheet.open {\n  transform: translate3d(0, 0, 0);\n}\n\n.mobile-travellers-sheet-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding-top: max(0.5rem, env(safe-area-inset-top, 0px));\n  padding-left: max(1rem, env(safe-area-inset-left, 0px));\n  padding-right: max(1rem, env(safe-area-inset-right, 0px));\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #e8e9ed;\n  box-sizing: border-box;\n}\n\n.mobile-travellers-sheet-section-label {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: clamp(0.9375rem, 4vw, 1rem);\n  font-weight: 700;\n  color: #20202a;\n  margin: 0 0 1rem 0;\n  line-height: 1.3;\n}\n\n.mobile-travellers-sheet-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior-y: contain;\n  touch-action: pan-y;\n  padding-top: 1rem;\n  padding-bottom: 1.25rem;\n  padding-left: max(clamp(1rem, 5vw, 1.25rem), env(safe-area-inset-left, 0px));\n  padding-right: max(clamp(1rem, 5vw, 1.25rem), env(safe-area-inset-right, 0px));\n  box-sizing: border-box;\n}\n\n.mobile-travellers-section {\n  margin-bottom: 1.25rem;\n}\n\n.mobile-travellers-section-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 0.5rem;\n  margin-bottom: 0.625rem;\n}\n\n.mobile-travellers-section-title {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-weight: 700;\n  font-size: clamp(0.875rem, 3.8vw, 0.9375rem);\n  color: #20202a;\n}\n\n.mobile-travellers-section-hint {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 0.75rem;\n  color: var(--yovo-grey-700, #686A7A);\n  flex-shrink: 0;\n}\n\n.mobile-travellers-num-row {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 0.5rem;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior-x: contain;\n  padding-bottom: 0.25rem;\n  scrollbar-width: none;\n}\n\n.mobile-travellers-num-row::-webkit-scrollbar {\n  display: none;\n}\n\n.mobile-travellers-num-chip {\n  flex: 0 0 auto;\n  min-width: 2.75rem;\n  min-height: 2.75rem;\n  padding: 0 0.35rem;\n  border-radius: 0.5rem;\n  border: 1px solid transparent;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n  background: #fff;\n  color: #20202a;\n  box-sizing: border-box;\n}\n\n.mobile-travellers-num-chip--active {\n  background: #c62842;\n  border-color: #c62842;\n  color: #fff;\n}\n\n.mobile-travellers-num-chip:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.mobile-travellers-class-heading {\n  display: block;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-weight: 700;\n  font-size: clamp(0.875rem, 3.8vw, 0.9375rem);\n  color: #20202a;\n  margin-bottom: 0.625rem;\n}\n\n.mobile-travellers-class-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.mobile-travellers-class-chip {\n  flex: 1 1 auto;\n  min-width: min(42%, 9.5rem);\n  padding: 0.65rem 0.75rem;\n  border-radius: 0.625rem;\n  border: none;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: clamp(0.8125rem, 3.2vw, 0.875rem);\n  font-weight: 600;\n  text-align: center;\n  cursor: pointer;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n  background: #f5f5f7;\n  color: #383a47;\n  box-sizing: border-box;\n}\n\n.mobile-travellers-class-chip--active {\n  background: #c62842;\n  color: #fff;\n}\n\n.mobile-travellers-sheet-footer {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding-top: 0.75rem;\n  padding-bottom: max(0.75rem, env(safe-area-inset-bottom, 0px));\n  padding-left: max(clamp(1rem, 5vw, 1.25rem), env(safe-area-inset-left, 0px));\n  padding-right: max(clamp(1rem, 5vw, 1.25rem), env(safe-area-inset-right, 0px));\n  border-top: 1px solid #e8e9ed;\n  background: #fff;\n  box-sizing: border-box;\n}\n\n.mobile-travellers-sheet-footer-summary {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.mobile-travellers-sheet-footer-line1 {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: clamp(0.8125rem, 3.2vw, 0.875rem);\n  font-weight: 700;\n  color: #20202a;\n  line-height: 1.35;\n}\n\n.mobile-travellers-sheet-footer-line2 {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: #aeaeb8;\n  margin-top: 0.125rem;\n  line-height: 1.35;\n}\n\n.mobile-travellers-sheet-save.MuiButton-root {\n  flex: 0 0 auto;\n  min-width: 6.5rem;\n  padding: 0.65rem 1.25rem !important;\n  border-radius: 0.875rem !important;\n  text-transform: none !important;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;\n  font-size: 1rem !important;\n  font-weight: 600 !important;\n  background-color: #20202a !important;\n  color: #fbfbfb !important;\n  box-shadow: none !important;\n}\n\n.mobile-travellers-sheet-save.MuiButton-root:hover {\n  background-color: #383a47 !important;\n  box-shadow: none !important;\n}\n\n/* Safe-area horizontal padding is applied on the sheet blocks above for all orientations */\n\n/* ===============================================\n   Passenger/Traveler Dropdown\n   =============================================== */\n\n.passenger-dropdown {\n  -webkit-tap-highlight-color: transparent;\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n}\n\n.passenger-dropdown-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 2px;\n}\n\n.passenger-dropdown-title {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 22px;\n  color: #16161D;\n}\n\n.passenger-dropdown-subtitle {\n  margin-top: 0;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  color: #8B8D98;\n}\n\n.passenger-dropdown-reset {\n  margin: 0;\n  padding: 2px 0;\n  border: 0;\n  background: transparent;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  color: #8B8D98;\n  cursor: pointer;\n}\n\n.passenger-dropdown-reset:hover {\n  color: #20202A;\n}\n\n.passenger-dropdown-rows {\n  display: flex;\n  flex-direction: column;\n}\n\n.passenger-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 0;\n  border-top: 1px solid #F0F1F5;\n}\n\n.passenger-row:first-child {\n  border-top: 0;\n}\n\n.passenger-row--locked {\n  opacity: 0.45;\n}\n\n.passenger-row-title {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 18px;\n  color: #16161D;\n}\n\n.passenger-row-hint {\n  margin-top: 0;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  color: #8B8D98;\n}\n\n.passenger-row-note {\n  margin-top: 2px;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 11px;\n  line-height: 14px;\n  color: #E65100;\n}\n\n.passenger-stepper {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  background: #F4F5F8;\n  border-radius: 999px;\n  padding: 3px;\n}\n\n.passenger-stepper-btn {\n  width: 28px;\n  height: 28px;\n  border: 0;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.passenger-stepper-btn--minus {\n  background: #FFFFFF;\n  color: #20202A;\n  box-shadow: 0 1px 2px rgba(22, 22, 29, 0.08);\n}\n\n.passenger-stepper-btn--plus {\n  background: #16161D;\n  color: #FFFFFF;\n}\n\n.passenger-stepper-btn:hover:not(:disabled) {\n  filter: brightness(0.96);\n}\n\n.passenger-stepper-btn:disabled {\n  background: #E6E7ED;\n  color: #C5C6CE;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n.passenger-stepper-value {\n  min-width: 20px;\n  text-align: center;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 20px;\n  color: #16161D;\n}\n\n.passenger-stepper-value--empty {\n  color: #B0B2BC;\n  font-weight: 600;\n}\n\n.passenger-dropdown-summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 2px;\n  padding: 6px 10px;\n  background: #F7F8FA;\n  border: 1px solid #ECEEF3;\n  border-radius: 10px;\n}\n\n.passenger-dropdown-summary-count {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 18px;\n  color: #4E5160;\n}\n\n.passenger-dropdown-summary-dot {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 1.5px solid #9A9CAA;\n  box-sizing: border-box;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.passenger-dropdown-summary-dot::after {\n  content: '';\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #9A9CAA;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.passenger-dropdown-summary-max {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 18px;\n  color: #8B8D98;\n}\n\n/* Homepage AI mascot must not bleed through the desktop travellers dropdown */\nbody[data-passenger-dropdown-open] .homepage-ai-travel-guide-mascot {\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.passenger-dropdown-label {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  line-height: 20px !important;\n  letter-spacing: 0.4px !important;\n  color: #545665 !important;\n  white-space: nowrap;\n}\n\n.passenger-counter-bar {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  background: #E8E9ED;\n  border-radius: 12px;\n  padding: 4px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.passenger-counter-btn {\n  width: 20px !important;\n  height: 22px !important;\n  min-width: 25px !important;\n  border-radius: 8px !important;\n  background-color: #20202A !important;\n  color: #FBFBFB !important;\n  font-size: 1.125rem !important;\n  font-weight: 600 !important;\n  padding: 0 !important;\n  line-height: 1 !important;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-appearance: none;\n  appearance: none;\n  transition: background-color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.passenger-counter-btn:hover {\n  background-color: #383A47 !important;\n}\n\n.passenger-counter-btn.Mui-disabled {\n  background-color: #C3C3CD !important;\n  color: #F5F5F7 !important;\n}\n\n.passenger-counter-value {\n  flex: 1 0 0;\n  text-align: center !important;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  line-height: 24px !important;\n}\n\n.passenger-done-btn {\n  width: 100% !important;\n  height: 40px !important;\n  background-color: #16161D !important;\n  color: #FFFFFF !important;\n  border-radius: 12px !important;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.1px !important;\n  line-height: 20px !important;\n  text-transform: none !important;\n  margin-top: 10px !important;\n  padding: 6px 16px !important;\n  box-shadow: none !important;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.passenger-done-btn:hover {\n  background-color: #383A47 !important;\n  box-shadow: none !important;\n}\n\n/* Mobile: ensure minimum tap targets */\n@media (max-width: 899.98px) {\n  .passenger-counter-btn {\n    min-height: 44px !important;\n    height: 44px !important;\n    min-width: 44px !important;\n    width: 44px !important;\n  }\n\n  .passenger-done-btn {\n    min-height: 40px !important;\n  }\n\n  .passenger-counter-bar {\n    gap: 16px;\n    padding: 4px;\n  }\n\n  /* iOS input zoom prevention */\n  .passenger-dropdown input {\n    font-size: 16px !important;\n    -webkit-appearance: none;\n    appearance: none;\n  }\n}\n\n/* iOS safe area for landscape */\n@supports (padding-left: env(safe-area-inset-left)) {\n  @media (orientation: landscape) and (hover: none) and (pointer: coarse) {\n    .passenger-dropdown {\n      padding-left: max(16px, env(safe-area-inset-left));\n      padding-right: max(16px, env(safe-area-inset-right));\n    }\n  }\n}\n\n/* ===============================================\n   Class Dropdown\n   =============================================== */\n\n/* MUI Select Menu sets Paper minWidth to the anchor width (often full row). Force content-sized menu. */\n.class-dropdown-paper.MuiPaper-root {\n  min-width: min-content !important;\n  width: max-content !important;\n  max-width: min(100vw - 32px, 220px) !important;\n  box-sizing: border-box;\n}\n\n.class-select-field {\n  overflow: visible !important;\n}\n\n/* Flush left: label “Class” and value “Economy” share the same x-origin (MUI adds default pl on select) */\n.class-select-field .MuiOutlinedInput-root {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.class-select-field .MuiSelect-select {\n  overflow: visible !important;\n  text-overflow: clip !important;\n  white-space: nowrap !important;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  min-width: 0;\n}\n\n.class-select-field .MuiInputBase-input {\n  overflow: visible !important;\n  text-overflow: clip !important;\n  padding-left: 0 !important;\n}\n\n.class-select-field .MuiOutlinedInput-root,\n.class-select-field .MuiInputBase-root {\n  overflow: visible !important;\n}\n\n.class-dropdown-item {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  line-height: 24px !important;\n  color: #545665 !important;\n  padding: 0 !important;\n  min-height: auto !important;\n  white-space: nowrap;\n  background: transparent !important;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.class-dropdown-item:hover {\n  color: #20202A !important;\n  background: transparent !important;\n}\n\n.class-dropdown-item.Mui-selected {\n  color: #20202A !important;\n  background: transparent !important;\n  font-weight: 700 !important;\n}\n\n.class-dropdown-item.Mui-selected:hover {\n  background: transparent !important;\n}\n\n/* Mobile: ensure proper tap targets */\n@media (max-width: 899.98px) {\n  .class-dropdown-item {\n    min-height: 44px !important;\n    display: flex !important;\n    align-items: center !important;\n  }\n}\n\n/* ===============================================\n   Special Fares — Fare Option Pills\n   =============================================== */\n\n.special-fare-pill-tooltip-trigger {\n  display: inline-flex;\n  max-width: 100%;\n}\n\n.special-fare-info-tooltip.MuiTooltip-tooltip {\n  background-color: #fff;\n  color: #20202A;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0.15px;\n  padding: 12px 14px;\n  max-width: 280px;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(32, 32, 42, 0.12);\n}\n\n.special-fare-info-tooltip .MuiTooltip-arrow {\n  color: #fff;\n}\n\n.special-fare-info-tooltip .MuiTooltip-arrow::before {\n  box-shadow: 0 2px 8px rgba(32, 32, 42, 0.08);\n}\n\n/* Mobile: (i) tap → centered white info popover (same copy as desktop hover tooltip) */\n.special-fare-info-sheet-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1410;\n  background: rgba(32, 32, 42, 0.35);\n}\n\n.special-fare-info-sheet {\n  position: fixed;\n  inset: 0;\n  z-index: 1411;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  padding-left: max(16px, env(safe-area-inset-left, 0px));\n  padding-right: max(16px, env(safe-area-inset-right, 0px));\n  pointer-events: none;\n}\n\n.special-fare-info-sheet-inner {\n  position: relative;\n  pointer-events: auto;\n  width: 100%;\n  max-width: 340px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(32, 32, 42, 0.12);\n  padding: 14px 16px;\n}\n\n.fare-option-pill {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  border-radius: 12px;\n  padding: 8px 12px;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.fare-option-radio {\n  width: 20px;\n  height: 20px;\n  display: block;\n  flex-shrink: 0;\n}\n\n.fare-option-title {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  line-height: 20px !important;\n  color: #20202A !important;\n  white-space: nowrap;\n}\n\n.fare-option-subtitle {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  line-height: 16px !important;\n  white-space: nowrap;\n}\n\n/* Mobile: compact fare pills, horizontal scroll */\n@media (max-width: 899.98px) {\n  .fare-option-pill {\n    min-height: 36px;\n    padding: 5px 10px;\n    gap: 6px;\n    border-radius: 8px;\n  }\n\n  .fare-option-radio {\n    width: 14px;\n    height: 14px;\n  }\n\n  .fare-option-title {\n    font-size: 11px !important;\n    line-height: 15px !important;\n  }\n\n  .fare-option-subtitle {\n    font-size: 10px !important;\n    line-height: 13px !important;\n  }\n\n  .special-fares-options {\n    -webkit-overflow-scrolling: touch;\n    scroll-snap-type: x proximity;\n    padding-bottom: 4px;\n    overflow-x: auto;\n    overflow-y: hidden;\n  }\n\n  .special-fares-options > div {\n    scroll-snap-align: start;\n    flex-shrink: 0;\n  }\n}\n\n\n/* ===============================================\n   Date Picker — Responsive (mobile compact)\n   =============================================== */\n@media (max-width: 899.98px) {\n  .custom-datepicker-single-month {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 4px !important;\n    width: 100% !important;\n    max-width: 100vw;\n    font-size: 13px;\n  }\n\n  .custom-datepicker-single-month .react-datepicker__month-container {\n    width: 100% !important;\n    float: none !important;\n  }\n\n  .custom-datepicker-single-month .react-datepicker__header {\n    padding-top: 6px;\n    padding-bottom: 4px;\n    font-size: 13px;\n  }\n\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__current-month {\n    font-size: 14px !important;\n    margin-bottom: 4px;\n  }\n\n  .custom-datepicker-single-month .react-datepicker__day-names {\n    margin-bottom: 0;\n  }\n\n  .custom-datepicker-single-month .react-datepicker__day-name {\n    width: 2rem;\n    line-height: 1.8rem;\n    font-size: 12px;\n    margin: 1px;\n  }\n\n  .custom-datepicker-single-month:not(.mobile-fullscreen-datepicker) .react-datepicker__day {\n    width: 2rem;\n    height: 2rem;\n    line-height: 2rem;\n    font-size: 13px;\n    margin: 1px;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  .custom-datepicker-single-month .react-datepicker__navigation {\n    top: 6px;\n  }\n}\n\n\n/* ===============================================\n   Airport Dropdown — Responsive Popper (compact)\n   =============================================== */\n@media (max-width: 899.98px) {\n  .MuiAutocomplete-popper {\n    left: 16px !important;\n    right: 16px !important;\n    width: calc(100vw - 32px) !important;\n  }\n\n  .flight-dropdown-search-bar {\n    padding: 8px 10px;\n    gap: 10px;\n    border-radius: 10px;\n  }\n\n  .flight-dropdown-search-input {\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  .flight-dropdown-option {\n    padding: 8px 12px;\n    min-height: 40px;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  .flight-dropdown-option-city {\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  .flight-dropdown-option-airport {\n    font-size: 12px;\n    line-height: 16px;\n  }\n\n  .flight-dropdown-option-code {\n    font-size: 13px;\n    margin-left: 8px;\n  }\n\n  .flight-dropdown-option-icon {\n    width: 18px;\n    height: 18px;\n    margin-right: 8px;\n    margin-top: 0 !important;\n  }\n\n  .flight-dropdown-separator {\n    font-size: 11px !important;\n    padding: 3px 6px !important;\n    margin: 4px 12px !important;\n  }\n}\n\n\n/* ===============================================\n   Passenger Dropdown — Compact mobile\n   =============================================== */\n@media (max-width: 899.98px) {\n  .passenger-dropdown {\n    border-radius: 14px !important;\n  }\n\n  .passenger-dropdown-label {\n    font-size: 13px !important;\n    line-height: 18px !important;\n  }\n\n  .passenger-counter-bar {\n    gap: 16px;\n    padding: 4px;\n    border-radius: 10px;\n  }\n\n  .passenger-counter-value {\n    font-size: 14px !important;\n    line-height: 20px !important;\n  }\n\n  .passenger-done-btn {\n    height: 40px !important;\n    font-size: 14px !important;\n    border-radius: 10px !important;\n    margin-top: 10px !important;\n  }\n}\n\n/* ===============================================\n   Class Dropdown — Compact mobile\n   =============================================== */\n@media (max-width: 899.98px) {\n  .class-dropdown-paper.MuiPaper-root {\n    border-radius: 12px !important;\n  }\n\n  .class-dropdown-item {\n    font-size: 14px !important;\n    line-height: 20px !important;\n    min-height: 40px !important;\n  }\n}\n\n@media (max-width: 899.98px) {\n  /* Mobile checkboxes section */\n  .flight-form-mobile-checkboxes {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 12px;\n    padding-top: 4px;\n  }\n\n  .flight-form-mobile-checkbox-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    -webkit-tap-highlight-color: transparent;\n    min-height: 44px;\n  }\n\n  .flight-form-mobile-checkbox-img {\n    width: 18px;\n    height: 18px;\n    flex-shrink: 0;\n  }\n\n  .flight-form-mobile-checkbox-label {\n    font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n    font-size: 13px !important;\n    font-weight: 400;\n    color: #20202A;\n  }\n}\n\n/* ===============================================\n   Multi-city homepage row — Figma desktop 2819:86711\n   + mobile reference (From | To | Date + trash).\n   Mirrors ExpandedMulticityForm.fs-emc-* patterns without importing\n   flight_select CSS (keeps homepage self-contained).\n   Swap control: Figma node 2819:182406 — use .flight-form-swap everywhere.\n   =============================================== */\n\n.flight-mc-remove {\n  flex-shrink: 0;\n  margin-left: clamp(12px, 1.5vw, 20px);\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.1875rem;\n  color: var(--neutrals-grey-800, #545665);\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n  align-self: center;\n  min-width: 56px;\n  text-align: left;\n  transition: color 0.2s ease;\n}\n.flight-mc-remove:hover {\n  color: #ce001f;\n  text-decoration: underline;\n}\n.flight-mc-remove:active {\n  background: none;\n  outline: none;\n  color: var(--neutrals-grey-800, #545665);\n  text-decoration: none;\n}\n.flight-mc-remove:focus:not(:focus-visible) {\n  outline: none;\n}\n.flight-mc-remove:focus-visible {\n  outline: 2px solid rgba(32, 32, 42, 0.4);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n.flight-mc-remove[data-disabled='true'] {\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.flight-mc-add-stop {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  min-height: 48px;\n  margin-top: 12px;\n  margin-bottom: 4px;\n  background: var(--Neutrals-grey-200, #e8e9ed);\n  border-radius: 16px;\n  cursor: pointer;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.1875rem;\n  color: var(--Neutrals-base-black, #20202a);\n  border: none;\n  padding: 6px 16px;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n  transition: background-color 0.2s ease;\n}\n.flight-mc-add-stop:hover {\n  background: var(--Neutrals-grey-300, #d6d9e0);\n}\n\n/* Mobile multicity — Figma 3888:47152 */\n.flight-mc-add-stop--mobile {\n  gap: 0;\n  min-height: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  letter-spacing: 0.25px;\n}\n\n/* Two-tone airport line (desktop); sits over transparent Autocomplete input */\n.flight-mc-airport-overlay {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  pointer-events: none;\n  z-index: 1;\n  min-height: 28px;\n}\n.flight-mc-airport-overlay--mobile {\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 6px;\n}\n.flight-mc-display-city {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 22px;\n  color: var(--Neutrals-base-black, #20202a);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n.flight-mc-display-iata {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 22px;\n  color: var(--Neutrals-grey-700, var(--yovo-grey-700, #686A7A));\n  flex-shrink: 0;\n}\n.flight-mc-display-placeholder {\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 22px;\n  color: var(--Neutrals-grey-700, var(--yovo-grey-700, #686A7A));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
